/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthRouteRouteImport } from './routes/_unauth/route'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthDashboardRouteRouteImport } from './routes/_auth/dashboard/route'
import { Route as UnauthResetPasswordIndexRouteImport } from './routes/_unauth/reset-password/index'
import { Route as UnauthLoginIndexRouteImport } from './routes/_unauth/login/index'
import { Route as UnauthForgotPasswordIndexRouteImport } from './routes/_unauth/forgot-password/index'
import { Route as AuthDashboardIndexRouteImport } from './routes/_auth/dashboard/index'
import { Route as AuthCustomerIndexRouteImport } from './routes/_auth/customer/index'
import { Route as sharedSsoIndexRouteImport } from './routes/(shared)/sso/index'
import { Route as sharedRedirectIndexRouteImport } from './routes/(shared)/redirect/index'
import { Route as sharedLogoutIndexRouteImport } from './routes/(shared)/logout/index'
import { Route as AuthDashboardOrganizationsRouteRouteImport } from './routes/_auth/dashboard/organizations/route'
import { Route as AuthCustomerLocationsRouteRouteImport } from './routes/_auth/customer/locations/route'
import { Route as UnauthAccountActivateIndexRouteImport } from './routes/_unauth/account/activate/index'
import { Route as AuthDashboardOrganizationsIndexRouteImport } from './routes/_auth/dashboard/organizations/index'
import { Route as AuthDashboardAccountIndexRouteImport } from './routes/_auth/dashboard/account/index'
import { Route as AuthCustomerLocationsIndexRouteImport } from './routes/_auth/customer/locations/index'
import { Route as AuthDashboardAccountUserIdRouteRouteImport } from './routes/_auth/dashboard/account/$userId/route'
import { Route as AuthCustomerLocationsModulesRouteRouteImport } from './routes/_auth/customer/locations/_modules/route'
import { Route as AuthDashboardOrganizationsOrganizationIdIndexRouteImport } from './routes/_auth/dashboard/organizations/$organizationId/index'
import { Route as AuthDashboardAccountUserIdIndexRouteImport } from './routes/_auth/dashboard/account/$userId/index'
import { Route as AuthCustomerLocationsLocationIdIndexRouteImport } from './routes/_auth/customer/locations/$locationId/index'
import { Route as AuthDashboardOrganizationsOrganizationIdSettingsRouteRouteImport } from './routes/_auth/dashboard/organizations/$organizationId/settings/route'
import { Route as AuthDashboardOrganizationsOrganizationIdadminRouteRouteImport } from './routes/_auth/dashboard/organizations/$organizationId/(admin)/route'
import { Route as AuthDashboardOrganizationsOrganizationIdUsersIndexRouteImport } from './routes/_auth/dashboard/organizations/$organizationId/users/index'
import { Route as AuthDashboardOrganizationsOrganizationIdSettingsIndexRouteImport } from './routes/_auth/dashboard/organizations/$organizationId/settings/index'
import { Route as AuthDashboardOrganizationsOrganizationIdRequestsIndexRouteImport } from './routes/_auth/dashboard/organizations/$organizationId/requests/index'
import { Route as AuthDashboardOrganizationsOrganizationIdProjectsIndexRouteImport } from './routes/_auth/dashboard/organizations/$organizationId/projects/index'
import { Route as AuthDashboardOrganizationsOrganizationIdPlanningIndexRouteImport } from './routes/_auth/dashboard/organizations/$organizationId/planning/index'
import { Route as AuthDashboardAccountUserIdSecurityIndexRouteImport } from './routes/_auth/dashboard/account/$userId/security/index'
import { Route as AuthDashboardAccountUserIdProfileIndexRouteImport } from './routes/_auth/dashboard/account/$userId/profile/index'
import { Route as AuthCustomerLocationsModulesElectricalIndexRouteImport } from './routes/_auth/customer/locations/_modules/electrical/index'
import { Route as AuthCustomerLocationsLocationIdWaterIndexRouteImport } from './routes/_auth/customer/locations/$locationId/water/index'
import { Route as AuthCustomerLocationsLocationIdSolarIndexRouteImport } from './routes/_auth/customer/locations/$locationId/solar/index'
import { Route as AuthCustomerLocationsLocationIdLegionellaIndexRouteImport } from './routes/_auth/customer/locations/$locationId/legionella/index'
import { Route as AuthCustomerLocationsLocationIdElectricalIndexRouteImport } from './routes/_auth/customer/locations/$locationId/electrical/index'
import { Route as AuthCustomerLocationsLocationIdAtexIndexRouteImport } from './routes/_auth/customer/locations/$locationId/atex/index'
import { Route as AuthCustomerLocationsLocationIdAirIndexRouteImport } from './routes/_auth/customer/locations/$locationId/air/index'
import { Route as AuthDashboardOrganizationsOrganizationIdSettingsVisualInspectionsIndexRouteImport } from './routes/_auth/dashboard/organizations/$organizationId/settings/visual-inspections/index'
import { Route as AuthDashboardOrganizationsOrganizationIdSettingsTemplatesIndexRouteImport } from './routes/_auth/dashboard/organizations/$organizationId/settings/templates/index'
import { Route as AuthDashboardOrganizationsOrganizationIdSettingsScope12IndexRouteImport } from './routes/_auth/dashboard/organizations/$organizationId/settings/scope12/index'
import { Route as AuthDashboardOrganizationsOrganizationIdSettingsRecommendationsIndexRouteImport } from './routes/_auth/dashboard/organizations/$organizationId/settings/recommendations/index'
import { Route as AuthDashboardOrganizationsOrganizationIdSettingsObservationsIndexRouteImport } from './routes/_auth/dashboard/organizations/$organizationId/settings/observations/index'
import { Route as AuthDashboardOrganizationsOrganizationIdSettingsNormsIndexRouteImport } from './routes/_auth/dashboard/organizations/$organizationId/settings/norms/index'
import { Route as AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsIndexRouteImport } from './routes/_auth/dashboard/organizations/$organizationId/settings/measuring-instruments/index'
import { Route as AuthDashboardOrganizationsOrganizationIdSettingsInspectionIndexRouteImport } from './routes/_auth/dashboard/organizations/$organizationId/settings/inspection/index'
import { Route as AuthDashboardOrganizationsOrganizationIdProjectsProjectVersionIdIndexRouteImport } from './routes/_auth/dashboard/organizations/$organizationId/projects/$projectVersionId/index'
import { Route as AuthDashboardOrganizationsOrganizationIdadminValidationIndexRouteImport } from './routes/_auth/dashboard/organizations/$organizationId/(admin)/validation/index'
import { Route as AuthCustomerLocationsLocationIdPreviewModuleTypeIndexRouteImport } from './routes/_auth/customer/locations/$locationId/preview/$moduleType/index'
import { Route as AuthCustomerLocationsLocationIdElectricalProjectsIndexRouteImport } from './routes/_auth/customer/locations/$locationId/electrical/projects/index'
import { Route as PublicCustomerLocationsLocationIdElectricalProjectsProjectIdRouteRouteImport } from './routes/_public/customer/locations/$locationId/electrical/projects/$projectId/route'
import { Route as PublicCustomerLocationsLocationIdElectricalProjectsProjectIdIndexRouteImport } from './routes/_public/customer/locations/$locationId/electrical/projects/$projectId/index'
import { Route as AuthDashboardOrganizationsOrganizationIdSettingsTemplatesTemplateIdIndexRouteImport } from './routes/_auth/dashboard/organizations/$organizationId/settings/templates/$templateId/index'
import { Route as AuthDashboardOrganizationsOrganizationIdSettingsScope12ScopeNameIndexRouteImport } from './routes/_auth/dashboard/organizations/$organizationId/settings/scope12/$scopeName/index'
import { Route as AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsMeasurementDeviceIdIndexRouteImport } from './routes/_auth/dashboard/organizations/$organizationId/settings/measuring-instruments/$measurementDeviceId/index'
import { Route as AuthDashboardOrganizationsOrganizationIdProjectsProjectVersionIdDocumentsIndexRouteImport } from './routes/_auth/dashboard/organizations/$organizationId/projects/$projectVersionId/documents/index'
import { Route as PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRouteImport } from './routes/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/route'
import { Route as AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsMeasurementDeviceIdCalibrationsIndexRouteImport } from './routes/_auth/dashboard/organizations/$organizationId/settings/measuring-instruments/$measurementDeviceId/calibrations/index'
import { Route as PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRouteImport } from './routes/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/route'
import { Route as PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsRouteRouteImport } from './routes/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_installations/route'
import { Route as PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsIndexRouteImport } from './routes/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/pv-installations/index'
import { Route as PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewOverviewIndexRouteImport } from './routes/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/overview/index'
import { Route as PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewFinalCircuitIndexRouteImport } from './routes/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/final-circuit/index'
import { Route as PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewDistributionBoardsIndexRouteImport } from './routes/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/distribution-boards/index'
import { Route as PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsPvInverterIdIndexRouteImport } from './routes/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/pv-installations/$pvInverterId/index'
import { Route as PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsFinalCircuitCircuitIdIndexRouteImport } from './routes/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_installations/final-circuit/$circuitId/index'
import { Route as PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsDistributionBoardsDistributionIdIndexRouteImport } from './routes/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_installations/distribution-boards/$distributionId/index'
import { Route as PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsPvInverterIdObservationsObservationIdIndexRouteImport } from './routes/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/pv-installations/$pvInverterId/observations/$observationId/index'
import { Route as PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdObservationsIndexRouteImport } from './routes/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/final-circuit/$circuitId/observations/index'
import { Route as PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdNotificationsIndexRouteImport } from './routes/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/final-circuit/$circuitId/notifications/index'
import { Route as PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdObservationsIndexRouteImport } from './routes/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/distribution-boards/$distributionId/observations/index'
import { Route as PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdNotificationsIndexRouteImport } from './routes/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/distribution-boards/$distributionId/notifications/index'
import { Route as PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdObservationsObservationIdIndexRouteImport } from './routes/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/final-circuit/$circuitId/observations/$observationId/index'
import { Route as PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdNotificationsNotificationIdIndexRouteImport } from './routes/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/final-circuit/$circuitId/notifications/$notificationId/index'
import { Route as PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdObservationsObservationIdIndexRouteImport } from './routes/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/distribution-boards/$distributionId/observations/$observationId/index'
import { Route as PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdNotificationsNotificationIdIndexRouteImport } from './routes/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/distribution-boards/$distributionId/notifications/$notificationId/index'

const UnauthRouteRoute = UnauthRouteRouteImport.update({
  id: '/_unauth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthDashboardRouteRoute = AuthDashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRouteRoute,
} as any)
const UnauthResetPasswordIndexRoute =
  UnauthResetPasswordIndexRouteImport.update({
    id: '/reset-password/',
    path: '/reset-password/',
    getParentRoute: () => UnauthRouteRoute,
  } as any)
const UnauthLoginIndexRoute = UnauthLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => UnauthRouteRoute,
} as any)
const UnauthForgotPasswordIndexRoute =
  UnauthForgotPasswordIndexRouteImport.update({
    id: '/forgot-password/',
    path: '/forgot-password/',
    getParentRoute: () => UnauthRouteRoute,
  } as any)
const AuthDashboardIndexRoute = AuthDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthDashboardRouteRoute,
} as any)
const AuthCustomerIndexRoute = AuthCustomerIndexRouteImport.update({
  id: '/customer/',
  path: '/customer/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const sharedSsoIndexRoute = sharedSsoIndexRouteImport.update({
  id: '/(shared)/sso/',
  path: '/sso/',
  getParentRoute: () => rootRouteImport,
} as any)
const sharedRedirectIndexRoute = sharedRedirectIndexRouteImport.update({
  id: '/(shared)/redirect/',
  path: '/redirect/',
  getParentRoute: () => rootRouteImport,
} as any)
const sharedLogoutIndexRoute = sharedLogoutIndexRouteImport.update({
  id: '/(shared)/logout/',
  path: '/logout/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthDashboardOrganizationsRouteRoute =
  AuthDashboardOrganizationsRouteRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AuthDashboardRouteRoute,
  } as any)
const AuthCustomerLocationsRouteRoute =
  AuthCustomerLocationsRouteRouteImport.update({
    id: '/customer/locations',
    path: '/customer/locations',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const UnauthAccountActivateIndexRoute =
  UnauthAccountActivateIndexRouteImport.update({
    id: '/account/activate/',
    path: '/account/activate/',
    getParentRoute: () => UnauthRouteRoute,
  } as any)
const AuthDashboardOrganizationsIndexRoute =
  AuthDashboardOrganizationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthDashboardOrganizationsRouteRoute,
  } as any)
const AuthDashboardAccountIndexRoute =
  AuthDashboardAccountIndexRouteImport.update({
    id: '/account/',
    path: '/account/',
    getParentRoute: () => AuthDashboardRouteRoute,
  } as any)
const AuthCustomerLocationsIndexRoute =
  AuthCustomerLocationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthCustomerLocationsRouteRoute,
  } as any)
const AuthDashboardAccountUserIdRouteRoute =
  AuthDashboardAccountUserIdRouteRouteImport.update({
    id: '/account/$userId',
    path: '/account/$userId',
    getParentRoute: () => AuthDashboardRouteRoute,
  } as any)
const AuthCustomerLocationsModulesRouteRoute =
  AuthCustomerLocationsModulesRouteRouteImport.update({
    id: '/_modules',
    getParentRoute: () => AuthCustomerLocationsRouteRoute,
  } as any)
const AuthDashboardOrganizationsOrganizationIdIndexRoute =
  AuthDashboardOrganizationsOrganizationIdIndexRouteImport.update({
    id: '/$organizationId/',
    path: '/$organizationId/',
    getParentRoute: () => AuthDashboardOrganizationsRouteRoute,
  } as any)
const AuthDashboardAccountUserIdIndexRoute =
  AuthDashboardAccountUserIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthDashboardAccountUserIdRouteRoute,
  } as any)
const AuthCustomerLocationsLocationIdIndexRoute =
  AuthCustomerLocationsLocationIdIndexRouteImport.update({
    id: '/$locationId/',
    path: '/$locationId/',
    getParentRoute: () => AuthCustomerLocationsRouteRoute,
  } as any)
const AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute =
  AuthDashboardOrganizationsOrganizationIdSettingsRouteRouteImport.update({
    id: '/$organizationId/settings',
    path: '/$organizationId/settings',
    getParentRoute: () => AuthDashboardOrganizationsRouteRoute,
  } as any)
const AuthDashboardOrganizationsOrganizationIdadminRouteRoute =
  AuthDashboardOrganizationsOrganizationIdadminRouteRouteImport.update({
    id: '/$organizationId/(admin)',
    path: '/$organizationId',
    getParentRoute: () => AuthDashboardOrganizationsRouteRoute,
  } as any)
const AuthDashboardOrganizationsOrganizationIdUsersIndexRoute =
  AuthDashboardOrganizationsOrganizationIdUsersIndexRouteImport.update({
    id: '/$organizationId/users/',
    path: '/$organizationId/users/',
    getParentRoute: () => AuthDashboardOrganizationsRouteRoute,
  } as any)
const AuthDashboardOrganizationsOrganizationIdSettingsIndexRoute =
  AuthDashboardOrganizationsOrganizationIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute,
  } as any)
const AuthDashboardOrganizationsOrganizationIdRequestsIndexRoute =
  AuthDashboardOrganizationsOrganizationIdRequestsIndexRouteImport.update({
    id: '/$organizationId/requests/',
    path: '/$organizationId/requests/',
    getParentRoute: () => AuthDashboardOrganizationsRouteRoute,
  } as any)
const AuthDashboardOrganizationsOrganizationIdProjectsIndexRoute =
  AuthDashboardOrganizationsOrganizationIdProjectsIndexRouteImport.update({
    id: '/$organizationId/projects/',
    path: '/$organizationId/projects/',
    getParentRoute: () => AuthDashboardOrganizationsRouteRoute,
  } as any)
const AuthDashboardOrganizationsOrganizationIdPlanningIndexRoute =
  AuthDashboardOrganizationsOrganizationIdPlanningIndexRouteImport.update({
    id: '/$organizationId/planning/',
    path: '/$organizationId/planning/',
    getParentRoute: () => AuthDashboardOrganizationsRouteRoute,
  } as any)
const AuthDashboardAccountUserIdSecurityIndexRoute =
  AuthDashboardAccountUserIdSecurityIndexRouteImport.update({
    id: '/security/',
    path: '/security/',
    getParentRoute: () => AuthDashboardAccountUserIdRouteRoute,
  } as any)
const AuthDashboardAccountUserIdProfileIndexRoute =
  AuthDashboardAccountUserIdProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => AuthDashboardAccountUserIdRouteRoute,
  } as any)
const AuthCustomerLocationsModulesElectricalIndexRoute =
  AuthCustomerLocationsModulesElectricalIndexRouteImport.update({
    id: '/electrical/',
    path: '/electrical/',
    getParentRoute: () => AuthCustomerLocationsModulesRouteRoute,
  } as any)
const AuthCustomerLocationsLocationIdWaterIndexRoute =
  AuthCustomerLocationsLocationIdWaterIndexRouteImport.update({
    id: '/$locationId/water/',
    path: '/$locationId/water/',
    getParentRoute: () => AuthCustomerLocationsRouteRoute,
  } as any)
const AuthCustomerLocationsLocationIdSolarIndexRoute =
  AuthCustomerLocationsLocationIdSolarIndexRouteImport.update({
    id: '/$locationId/solar/',
    path: '/$locationId/solar/',
    getParentRoute: () => AuthCustomerLocationsRouteRoute,
  } as any)
const AuthCustomerLocationsLocationIdLegionellaIndexRoute =
  AuthCustomerLocationsLocationIdLegionellaIndexRouteImport.update({
    id: '/$locationId/legionella/',
    path: '/$locationId/legionella/',
    getParentRoute: () => AuthCustomerLocationsRouteRoute,
  } as any)
const AuthCustomerLocationsLocationIdElectricalIndexRoute =
  AuthCustomerLocationsLocationIdElectricalIndexRouteImport.update({
    id: '/$locationId/electrical/',
    path: '/$locationId/electrical/',
    getParentRoute: () => AuthCustomerLocationsRouteRoute,
  } as any)
const AuthCustomerLocationsLocationIdAtexIndexRoute =
  AuthCustomerLocationsLocationIdAtexIndexRouteImport.update({
    id: '/$locationId/atex/',
    path: '/$locationId/atex/',
    getParentRoute: () => AuthCustomerLocationsRouteRoute,
  } as any)
const AuthCustomerLocationsLocationIdAirIndexRoute =
  AuthCustomerLocationsLocationIdAirIndexRouteImport.update({
    id: '/$locationId/air/',
    path: '/$locationId/air/',
    getParentRoute: () => AuthCustomerLocationsRouteRoute,
  } as any)
const AuthDashboardOrganizationsOrganizationIdSettingsVisualInspectionsIndexRoute =
  AuthDashboardOrganizationsOrganizationIdSettingsVisualInspectionsIndexRouteImport.update(
    {
      id: '/visual-inspections/',
      path: '/visual-inspections/',
      getParentRoute: () =>
        AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute,
    } as any,
  )
const AuthDashboardOrganizationsOrganizationIdSettingsTemplatesIndexRoute =
  AuthDashboardOrganizationsOrganizationIdSettingsTemplatesIndexRouteImport.update(
    {
      id: '/templates/',
      path: '/templates/',
      getParentRoute: () =>
        AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute,
    } as any,
  )
const AuthDashboardOrganizationsOrganizationIdSettingsScope12IndexRoute =
  AuthDashboardOrganizationsOrganizationIdSettingsScope12IndexRouteImport.update(
    {
      id: '/scope12/',
      path: '/scope12/',
      getParentRoute: () =>
        AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute,
    } as any,
  )
const AuthDashboardOrganizationsOrganizationIdSettingsRecommendationsIndexRoute =
  AuthDashboardOrganizationsOrganizationIdSettingsRecommendationsIndexRouteImport.update(
    {
      id: '/recommendations/',
      path: '/recommendations/',
      getParentRoute: () =>
        AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute,
    } as any,
  )
const AuthDashboardOrganizationsOrganizationIdSettingsObservationsIndexRoute =
  AuthDashboardOrganizationsOrganizationIdSettingsObservationsIndexRouteImport.update(
    {
      id: '/observations/',
      path: '/observations/',
      getParentRoute: () =>
        AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute,
    } as any,
  )
const AuthDashboardOrganizationsOrganizationIdSettingsNormsIndexRoute =
  AuthDashboardOrganizationsOrganizationIdSettingsNormsIndexRouteImport.update({
    id: '/norms/',
    path: '/norms/',
    getParentRoute: () =>
      AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute,
  } as any)
const AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsIndexRoute =
  AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsIndexRouteImport.update(
    {
      id: '/measuring-instruments/',
      path: '/measuring-instruments/',
      getParentRoute: () =>
        AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute,
    } as any,
  )
const AuthDashboardOrganizationsOrganizationIdSettingsInspectionIndexRoute =
  AuthDashboardOrganizationsOrganizationIdSettingsInspectionIndexRouteImport.update(
    {
      id: '/inspection/',
      path: '/inspection/',
      getParentRoute: () =>
        AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute,
    } as any,
  )
const AuthDashboardOrganizationsOrganizationIdProjectsProjectVersionIdIndexRoute =
  AuthDashboardOrganizationsOrganizationIdProjectsProjectVersionIdIndexRouteImport.update(
    {
      id: '/$organizationId/projects/$projectVersionId/',
      path: '/$organizationId/projects/$projectVersionId/',
      getParentRoute: () => AuthDashboardOrganizationsRouteRoute,
    } as any,
  )
const AuthDashboardOrganizationsOrganizationIdadminValidationIndexRoute =
  AuthDashboardOrganizationsOrganizationIdadminValidationIndexRouteImport.update(
    {
      id: '/validation/',
      path: '/validation/',
      getParentRoute: () =>
        AuthDashboardOrganizationsOrganizationIdadminRouteRoute,
    } as any,
  )
const AuthCustomerLocationsLocationIdPreviewModuleTypeIndexRoute =
  AuthCustomerLocationsLocationIdPreviewModuleTypeIndexRouteImport.update({
    id: '/$locationId/preview/$moduleType/',
    path: '/$locationId/preview/$moduleType/',
    getParentRoute: () => AuthCustomerLocationsRouteRoute,
  } as any)
const AuthCustomerLocationsLocationIdElectricalProjectsIndexRoute =
  AuthCustomerLocationsLocationIdElectricalProjectsIndexRouteImport.update({
    id: '/$locationId/electrical/projects/',
    path: '/$locationId/electrical/projects/',
    getParentRoute: () => AuthCustomerLocationsRouteRoute,
  } as any)
const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdRouteRoute =
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdRouteRouteImport.update(
    {
      id: '/_public/customer/locations/$locationId/electrical/projects/$projectId',
      path: '/customer/locations/$locationId/electrical/projects/$projectId',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdIndexRoute =
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        PublicCustomerLocationsLocationIdElectricalProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthDashboardOrganizationsOrganizationIdSettingsTemplatesTemplateIdIndexRoute =
  AuthDashboardOrganizationsOrganizationIdSettingsTemplatesTemplateIdIndexRouteImport.update(
    {
      id: '/templates/$templateId/',
      path: '/templates/$templateId/',
      getParentRoute: () =>
        AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute,
    } as any,
  )
const AuthDashboardOrganizationsOrganizationIdSettingsScope12ScopeNameIndexRoute =
  AuthDashboardOrganizationsOrganizationIdSettingsScope12ScopeNameIndexRouteImport.update(
    {
      id: '/scope12/$scopeName/',
      path: '/scope12/$scopeName/',
      getParentRoute: () =>
        AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute,
    } as any,
  )
const AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsMeasurementDeviceIdIndexRoute =
  AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsMeasurementDeviceIdIndexRouteImport.update(
    {
      id: '/measuring-instruments/$measurementDeviceId/',
      path: '/measuring-instruments/$measurementDeviceId/',
      getParentRoute: () =>
        AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute,
    } as any,
  )
const AuthDashboardOrganizationsOrganizationIdProjectsProjectVersionIdDocumentsIndexRoute =
  AuthDashboardOrganizationsOrganizationIdProjectsProjectVersionIdDocumentsIndexRouteImport.update(
    {
      id: '/$organizationId/projects/$projectVersionId/documents/',
      path: '/$organizationId/projects/$projectVersionId/documents/',
      getParentRoute: () => AuthDashboardOrganizationsRouteRoute,
    } as any,
  )
const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRoute =
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRouteImport.update(
    {
      id: '/_overview',
      getParentRoute: () =>
        PublicCustomerLocationsLocationIdElectricalProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsMeasurementDeviceIdCalibrationsIndexRoute =
  AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsMeasurementDeviceIdCalibrationsIndexRouteImport.update(
    {
      id: '/measuring-instruments/$measurementDeviceId/calibrations/',
      path: '/measuring-instruments/$measurementDeviceId/calibrations/',
      getParentRoute: () =>
        AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute,
    } as any,
  )
const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRoute =
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRouteImport.update(
    {
      id: '/_details/_reports',
      getParentRoute: () =>
        PublicCustomerLocationsLocationIdElectricalProjectsProjectIdRouteRoute,
    } as any,
  )
const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsRouteRoute =
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsRouteRouteImport.update(
    {
      id: '/_details/_installations',
      getParentRoute: () =>
        PublicCustomerLocationsLocationIdElectricalProjectsProjectIdRouteRoute,
    } as any,
  )
const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsIndexRoute =
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsIndexRouteImport.update(
    {
      id: '/pv-installations/',
      path: '/pv-installations/',
      getParentRoute: () =>
        PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRoute,
    } as any,
  )
const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewOverviewIndexRoute =
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewOverviewIndexRouteImport.update(
    {
      id: '/overview/',
      path: '/overview/',
      getParentRoute: () =>
        PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRoute,
    } as any,
  )
const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewFinalCircuitIndexRoute =
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewFinalCircuitIndexRouteImport.update(
    {
      id: '/final-circuit/',
      path: '/final-circuit/',
      getParentRoute: () =>
        PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRoute,
    } as any,
  )
const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewDistributionBoardsIndexRoute =
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewDistributionBoardsIndexRouteImport.update(
    {
      id: '/distribution-boards/',
      path: '/distribution-boards/',
      getParentRoute: () =>
        PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRoute,
    } as any,
  )
const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsPvInverterIdIndexRoute =
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsPvInverterIdIndexRouteImport.update(
    {
      id: '/pv-installations/$pvInverterId/',
      path: '/pv-installations/$pvInverterId/',
      getParentRoute: () =>
        PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRoute,
    } as any,
  )
const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsFinalCircuitCircuitIdIndexRoute =
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsFinalCircuitCircuitIdIndexRouteImport.update(
    {
      id: '/final-circuit/$circuitId/',
      path: '/final-circuit/$circuitId/',
      getParentRoute: () =>
        PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsRouteRoute,
    } as any,
  )
const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsDistributionBoardsDistributionIdIndexRoute =
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsDistributionBoardsDistributionIdIndexRouteImport.update(
    {
      id: '/distribution-boards/$distributionId/',
      path: '/distribution-boards/$distributionId/',
      getParentRoute: () =>
        PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsRouteRoute,
    } as any,
  )
const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsPvInverterIdObservationsObservationIdIndexRoute =
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsPvInverterIdObservationsObservationIdIndexRouteImport.update(
    {
      id: '/pv-installations/$pvInverterId/observations/$observationId/',
      path: '/pv-installations/$pvInverterId/observations/$observationId/',
      getParentRoute: () =>
        PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRoute,
    } as any,
  )
const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdObservationsIndexRoute =
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdObservationsIndexRouteImport.update(
    {
      id: '/final-circuit/$circuitId/observations/',
      path: '/final-circuit/$circuitId/observations/',
      getParentRoute: () =>
        PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRoute,
    } as any,
  )
const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdNotificationsIndexRoute =
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdNotificationsIndexRouteImport.update(
    {
      id: '/final-circuit/$circuitId/notifications/',
      path: '/final-circuit/$circuitId/notifications/',
      getParentRoute: () =>
        PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRoute,
    } as any,
  )
const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdObservationsIndexRoute =
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdObservationsIndexRouteImport.update(
    {
      id: '/distribution-boards/$distributionId/observations/',
      path: '/distribution-boards/$distributionId/observations/',
      getParentRoute: () =>
        PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRoute,
    } as any,
  )
const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdNotificationsIndexRoute =
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdNotificationsIndexRouteImport.update(
    {
      id: '/distribution-boards/$distributionId/notifications/',
      path: '/distribution-boards/$distributionId/notifications/',
      getParentRoute: () =>
        PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRoute,
    } as any,
  )
const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdObservationsObservationIdIndexRoute =
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdObservationsObservationIdIndexRouteImport.update(
    {
      id: '/final-circuit/$circuitId/observations/$observationId/',
      path: '/final-circuit/$circuitId/observations/$observationId/',
      getParentRoute: () =>
        PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRoute,
    } as any,
  )
const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdNotificationsNotificationIdIndexRoute =
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdNotificationsNotificationIdIndexRouteImport.update(
    {
      id: '/final-circuit/$circuitId/notifications/$notificationId/',
      path: '/final-circuit/$circuitId/notifications/$notificationId/',
      getParentRoute: () =>
        PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRoute,
    } as any,
  )
const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdObservationsObservationIdIndexRoute =
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdObservationsObservationIdIndexRouteImport.update(
    {
      id: '/distribution-boards/$distributionId/observations/$observationId/',
      path: '/distribution-boards/$distributionId/observations/$observationId/',
      getParentRoute: () =>
        PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRoute,
    } as any,
  )
const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdNotificationsNotificationIdIndexRoute =
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdNotificationsNotificationIdIndexRouteImport.update(
    {
      id: '/distribution-boards/$distributionId/notifications/$notificationId/',
      path: '/distribution-boards/$distributionId/notifications/$notificationId/',
      getParentRoute: () =>
        PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof AuthDashboardRouteRouteWithChildren
  '/customer/locations': typeof AuthCustomerLocationsModulesRouteRouteWithChildren
  '/dashboard/organizations': typeof AuthDashboardOrganizationsRouteRouteWithChildren
  '/logout': typeof sharedLogoutIndexRoute
  '/redirect': typeof sharedRedirectIndexRoute
  '/sso': typeof sharedSsoIndexRoute
  '/customer': typeof AuthCustomerIndexRoute
  '/dashboard/': typeof AuthDashboardIndexRoute
  '/forgot-password': typeof UnauthForgotPasswordIndexRoute
  '/login': typeof UnauthLoginIndexRoute
  '/reset-password': typeof UnauthResetPasswordIndexRoute
  '/dashboard/account/$userId': typeof AuthDashboardAccountUserIdRouteRouteWithChildren
  '/customer/locations/': typeof AuthCustomerLocationsIndexRoute
  '/dashboard/account': typeof AuthDashboardAccountIndexRoute
  '/dashboard/organizations/': typeof AuthDashboardOrganizationsIndexRoute
  '/account/activate': typeof UnauthAccountActivateIndexRoute
  '/dashboard/organizations/$organizationId': typeof AuthDashboardOrganizationsOrganizationIdIndexRoute
  '/dashboard/organizations/$organizationId/settings': typeof AuthDashboardOrganizationsOrganizationIdSettingsRouteRouteWithChildren
  '/customer/locations/$locationId': typeof AuthCustomerLocationsLocationIdIndexRoute
  '/dashboard/account/$userId/': typeof AuthDashboardAccountUserIdIndexRoute
  '/customer/locations/$locationId/air': typeof AuthCustomerLocationsLocationIdAirIndexRoute
  '/customer/locations/$locationId/atex': typeof AuthCustomerLocationsLocationIdAtexIndexRoute
  '/customer/locations/$locationId/electrical': typeof AuthCustomerLocationsLocationIdElectricalIndexRoute
  '/customer/locations/$locationId/legionella': typeof AuthCustomerLocationsLocationIdLegionellaIndexRoute
  '/customer/locations/$locationId/solar': typeof AuthCustomerLocationsLocationIdSolarIndexRoute
  '/customer/locations/$locationId/water': typeof AuthCustomerLocationsLocationIdWaterIndexRoute
  '/customer/locations/electrical': typeof AuthCustomerLocationsModulesElectricalIndexRoute
  '/dashboard/account/$userId/profile': typeof AuthDashboardAccountUserIdProfileIndexRoute
  '/dashboard/account/$userId/security': typeof AuthDashboardAccountUserIdSecurityIndexRoute
  '/dashboard/organizations/$organizationId/planning': typeof AuthDashboardOrganizationsOrganizationIdPlanningIndexRoute
  '/dashboard/organizations/$organizationId/projects': typeof AuthDashboardOrganizationsOrganizationIdProjectsIndexRoute
  '/dashboard/organizations/$organizationId/requests': typeof AuthDashboardOrganizationsOrganizationIdRequestsIndexRoute
  '/dashboard/organizations/$organizationId/settings/': typeof AuthDashboardOrganizationsOrganizationIdSettingsIndexRoute
  '/dashboard/organizations/$organizationId/users': typeof AuthDashboardOrganizationsOrganizationIdUsersIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRouteWithChildren
  '/customer/locations/$locationId/electrical/projects': typeof AuthCustomerLocationsLocationIdElectricalProjectsIndexRoute
  '/customer/locations/$locationId/preview/$moduleType': typeof AuthCustomerLocationsLocationIdPreviewModuleTypeIndexRoute
  '/dashboard/organizations/$organizationId/validation': typeof AuthDashboardOrganizationsOrganizationIdadminValidationIndexRoute
  '/dashboard/organizations/$organizationId/projects/$projectVersionId': typeof AuthDashboardOrganizationsOrganizationIdProjectsProjectVersionIdIndexRoute
  '/dashboard/organizations/$organizationId/settings/inspection': typeof AuthDashboardOrganizationsOrganizationIdSettingsInspectionIndexRoute
  '/dashboard/organizations/$organizationId/settings/measuring-instruments': typeof AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsIndexRoute
  '/dashboard/organizations/$organizationId/settings/norms': typeof AuthDashboardOrganizationsOrganizationIdSettingsNormsIndexRoute
  '/dashboard/organizations/$organizationId/settings/observations': typeof AuthDashboardOrganizationsOrganizationIdSettingsObservationsIndexRoute
  '/dashboard/organizations/$organizationId/settings/recommendations': typeof AuthDashboardOrganizationsOrganizationIdSettingsRecommendationsIndexRoute
  '/dashboard/organizations/$organizationId/settings/scope12': typeof AuthDashboardOrganizationsOrganizationIdSettingsScope12IndexRoute
  '/dashboard/organizations/$organizationId/settings/templates': typeof AuthDashboardOrganizationsOrganizationIdSettingsTemplatesIndexRoute
  '/dashboard/organizations/$organizationId/settings/visual-inspections': typeof AuthDashboardOrganizationsOrganizationIdSettingsVisualInspectionsIndexRoute
  '/dashboard/organizations/$organizationId/projects/$projectVersionId/documents': typeof AuthDashboardOrganizationsOrganizationIdProjectsProjectVersionIdDocumentsIndexRoute
  '/dashboard/organizations/$organizationId/settings/measuring-instruments/$measurementDeviceId': typeof AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsMeasurementDeviceIdIndexRoute
  '/dashboard/organizations/$organizationId/settings/scope12/$scopeName': typeof AuthDashboardOrganizationsOrganizationIdSettingsScope12ScopeNameIndexRoute
  '/dashboard/organizations/$organizationId/settings/templates/$templateId': typeof AuthDashboardOrganizationsOrganizationIdSettingsTemplatesTemplateIdIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdIndexRoute
  '/dashboard/organizations/$organizationId/settings/measuring-instruments/$measurementDeviceId/calibrations': typeof AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsMeasurementDeviceIdCalibrationsIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewDistributionBoardsIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewFinalCircuitIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/overview': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewOverviewIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/pv-installations': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/pv-installations/$pvInverterId': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsPvInverterIdIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsDistributionBoardsDistributionIdIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsFinalCircuitCircuitIdIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId/notifications': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdNotificationsIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId/observations': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdObservationsIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId/notifications': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdNotificationsIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId/observations': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdObservationsIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/pv-installations/$pvInverterId/observations/$observationId': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsPvInverterIdObservationsObservationIdIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId/notifications/$notificationId': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdNotificationsNotificationIdIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId/observations/$observationId': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdObservationsObservationIdIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId/notifications/$notificationId': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdNotificationsNotificationIdIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId/observations/$observationId': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdObservationsObservationIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/logout': typeof sharedLogoutIndexRoute
  '/redirect': typeof sharedRedirectIndexRoute
  '/sso': typeof sharedSsoIndexRoute
  '/customer': typeof AuthCustomerIndexRoute
  '/dashboard': typeof AuthDashboardIndexRoute
  '/forgot-password': typeof UnauthForgotPasswordIndexRoute
  '/login': typeof UnauthLoginIndexRoute
  '/reset-password': typeof UnauthResetPasswordIndexRoute
  '/customer/locations': typeof AuthCustomerLocationsIndexRoute
  '/dashboard/account': typeof AuthDashboardAccountIndexRoute
  '/dashboard/organizations': typeof AuthDashboardOrganizationsIndexRoute
  '/account/activate': typeof UnauthAccountActivateIndexRoute
  '/dashboard/organizations/$organizationId': typeof AuthDashboardOrganizationsOrganizationIdIndexRoute
  '/customer/locations/$locationId': typeof AuthCustomerLocationsLocationIdIndexRoute
  '/dashboard/account/$userId': typeof AuthDashboardAccountUserIdIndexRoute
  '/customer/locations/$locationId/air': typeof AuthCustomerLocationsLocationIdAirIndexRoute
  '/customer/locations/$locationId/atex': typeof AuthCustomerLocationsLocationIdAtexIndexRoute
  '/customer/locations/$locationId/electrical': typeof AuthCustomerLocationsLocationIdElectricalIndexRoute
  '/customer/locations/$locationId/legionella': typeof AuthCustomerLocationsLocationIdLegionellaIndexRoute
  '/customer/locations/$locationId/solar': typeof AuthCustomerLocationsLocationIdSolarIndexRoute
  '/customer/locations/$locationId/water': typeof AuthCustomerLocationsLocationIdWaterIndexRoute
  '/customer/locations/electrical': typeof AuthCustomerLocationsModulesElectricalIndexRoute
  '/dashboard/account/$userId/profile': typeof AuthDashboardAccountUserIdProfileIndexRoute
  '/dashboard/account/$userId/security': typeof AuthDashboardAccountUserIdSecurityIndexRoute
  '/dashboard/organizations/$organizationId/planning': typeof AuthDashboardOrganizationsOrganizationIdPlanningIndexRoute
  '/dashboard/organizations/$organizationId/projects': typeof AuthDashboardOrganizationsOrganizationIdProjectsIndexRoute
  '/dashboard/organizations/$organizationId/requests': typeof AuthDashboardOrganizationsOrganizationIdRequestsIndexRoute
  '/dashboard/organizations/$organizationId/settings': typeof AuthDashboardOrganizationsOrganizationIdSettingsIndexRoute
  '/dashboard/organizations/$organizationId/users': typeof AuthDashboardOrganizationsOrganizationIdUsersIndexRoute
  '/customer/locations/$locationId/electrical/projects': typeof AuthCustomerLocationsLocationIdElectricalProjectsIndexRoute
  '/customer/locations/$locationId/preview/$moduleType': typeof AuthCustomerLocationsLocationIdPreviewModuleTypeIndexRoute
  '/dashboard/organizations/$organizationId/validation': typeof AuthDashboardOrganizationsOrganizationIdadminValidationIndexRoute
  '/dashboard/organizations/$organizationId/projects/$projectVersionId': typeof AuthDashboardOrganizationsOrganizationIdProjectsProjectVersionIdIndexRoute
  '/dashboard/organizations/$organizationId/settings/inspection': typeof AuthDashboardOrganizationsOrganizationIdSettingsInspectionIndexRoute
  '/dashboard/organizations/$organizationId/settings/measuring-instruments': typeof AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsIndexRoute
  '/dashboard/organizations/$organizationId/settings/norms': typeof AuthDashboardOrganizationsOrganizationIdSettingsNormsIndexRoute
  '/dashboard/organizations/$organizationId/settings/observations': typeof AuthDashboardOrganizationsOrganizationIdSettingsObservationsIndexRoute
  '/dashboard/organizations/$organizationId/settings/recommendations': typeof AuthDashboardOrganizationsOrganizationIdSettingsRecommendationsIndexRoute
  '/dashboard/organizations/$organizationId/settings/scope12': typeof AuthDashboardOrganizationsOrganizationIdSettingsScope12IndexRoute
  '/dashboard/organizations/$organizationId/settings/templates': typeof AuthDashboardOrganizationsOrganizationIdSettingsTemplatesIndexRoute
  '/dashboard/organizations/$organizationId/settings/visual-inspections': typeof AuthDashboardOrganizationsOrganizationIdSettingsVisualInspectionsIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRouteWithChildren
  '/dashboard/organizations/$organizationId/projects/$projectVersionId/documents': typeof AuthDashboardOrganizationsOrganizationIdProjectsProjectVersionIdDocumentsIndexRoute
  '/dashboard/organizations/$organizationId/settings/measuring-instruments/$measurementDeviceId': typeof AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsMeasurementDeviceIdIndexRoute
  '/dashboard/organizations/$organizationId/settings/scope12/$scopeName': typeof AuthDashboardOrganizationsOrganizationIdSettingsScope12ScopeNameIndexRoute
  '/dashboard/organizations/$organizationId/settings/templates/$templateId': typeof AuthDashboardOrganizationsOrganizationIdSettingsTemplatesTemplateIdIndexRoute
  '/dashboard/organizations/$organizationId/settings/measuring-instruments/$measurementDeviceId/calibrations': typeof AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsMeasurementDeviceIdCalibrationsIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewDistributionBoardsIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewFinalCircuitIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/overview': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewOverviewIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/pv-installations': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/pv-installations/$pvInverterId': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsPvInverterIdIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsDistributionBoardsDistributionIdIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsFinalCircuitCircuitIdIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId/notifications': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdNotificationsIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId/observations': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdObservationsIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId/notifications': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdNotificationsIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId/observations': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdObservationsIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/pv-installations/$pvInverterId/observations/$observationId': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsPvInverterIdObservationsObservationIdIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId/notifications/$notificationId': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdNotificationsNotificationIdIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId/observations/$observationId': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdObservationsObservationIdIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId/notifications/$notificationId': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdNotificationsNotificationIdIndexRoute
  '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId/observations/$observationId': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdObservationsObservationIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteRouteWithChildren
  '/_unauth': typeof UnauthRouteRouteWithChildren
  '/_auth/dashboard': typeof AuthDashboardRouteRouteWithChildren
  '/_auth/customer/locations': typeof AuthCustomerLocationsRouteRouteWithChildren
  '/_auth/dashboard/organizations': typeof AuthDashboardOrganizationsRouteRouteWithChildren
  '/(shared)/logout/': typeof sharedLogoutIndexRoute
  '/(shared)/redirect/': typeof sharedRedirectIndexRoute
  '/(shared)/sso/': typeof sharedSsoIndexRoute
  '/_auth/customer/': typeof AuthCustomerIndexRoute
  '/_auth/dashboard/': typeof AuthDashboardIndexRoute
  '/_unauth/forgot-password/': typeof UnauthForgotPasswordIndexRoute
  '/_unauth/login/': typeof UnauthLoginIndexRoute
  '/_unauth/reset-password/': typeof UnauthResetPasswordIndexRoute
  '/_auth/customer/locations/_modules': typeof AuthCustomerLocationsModulesRouteRouteWithChildren
  '/_auth/dashboard/account/$userId': typeof AuthDashboardAccountUserIdRouteRouteWithChildren
  '/_auth/customer/locations/': typeof AuthCustomerLocationsIndexRoute
  '/_auth/dashboard/account/': typeof AuthDashboardAccountIndexRoute
  '/_auth/dashboard/organizations/': typeof AuthDashboardOrganizationsIndexRoute
  '/_unauth/account/activate/': typeof UnauthAccountActivateIndexRoute
  '/_auth/dashboard/organizations/$organizationId/(admin)': typeof AuthDashboardOrganizationsOrganizationIdadminRouteRouteWithChildren
  '/_auth/dashboard/organizations/$organizationId/settings': typeof AuthDashboardOrganizationsOrganizationIdSettingsRouteRouteWithChildren
  '/_auth/customer/locations/$locationId/': typeof AuthCustomerLocationsLocationIdIndexRoute
  '/_auth/dashboard/account/$userId/': typeof AuthDashboardAccountUserIdIndexRoute
  '/_auth/dashboard/organizations/$organizationId/': typeof AuthDashboardOrganizationsOrganizationIdIndexRoute
  '/_auth/customer/locations/$locationId/air/': typeof AuthCustomerLocationsLocationIdAirIndexRoute
  '/_auth/customer/locations/$locationId/atex/': typeof AuthCustomerLocationsLocationIdAtexIndexRoute
  '/_auth/customer/locations/$locationId/electrical/': typeof AuthCustomerLocationsLocationIdElectricalIndexRoute
  '/_auth/customer/locations/$locationId/legionella/': typeof AuthCustomerLocationsLocationIdLegionellaIndexRoute
  '/_auth/customer/locations/$locationId/solar/': typeof AuthCustomerLocationsLocationIdSolarIndexRoute
  '/_auth/customer/locations/$locationId/water/': typeof AuthCustomerLocationsLocationIdWaterIndexRoute
  '/_auth/customer/locations/_modules/electrical/': typeof AuthCustomerLocationsModulesElectricalIndexRoute
  '/_auth/dashboard/account/$userId/profile/': typeof AuthDashboardAccountUserIdProfileIndexRoute
  '/_auth/dashboard/account/$userId/security/': typeof AuthDashboardAccountUserIdSecurityIndexRoute
  '/_auth/dashboard/organizations/$organizationId/planning/': typeof AuthDashboardOrganizationsOrganizationIdPlanningIndexRoute
  '/_auth/dashboard/organizations/$organizationId/projects/': typeof AuthDashboardOrganizationsOrganizationIdProjectsIndexRoute
  '/_auth/dashboard/organizations/$organizationId/requests/': typeof AuthDashboardOrganizationsOrganizationIdRequestsIndexRoute
  '/_auth/dashboard/organizations/$organizationId/settings/': typeof AuthDashboardOrganizationsOrganizationIdSettingsIndexRoute
  '/_auth/dashboard/organizations/$organizationId/users/': typeof AuthDashboardOrganizationsOrganizationIdUsersIndexRoute
  '/_public/customer/locations/$locationId/electrical/projects/$projectId': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdRouteRouteWithChildren
  '/_auth/customer/locations/$locationId/electrical/projects/': typeof AuthCustomerLocationsLocationIdElectricalProjectsIndexRoute
  '/_auth/customer/locations/$locationId/preview/$moduleType/': typeof AuthCustomerLocationsLocationIdPreviewModuleTypeIndexRoute
  '/_auth/dashboard/organizations/$organizationId/(admin)/validation/': typeof AuthDashboardOrganizationsOrganizationIdadminValidationIndexRoute
  '/_auth/dashboard/organizations/$organizationId/projects/$projectVersionId/': typeof AuthDashboardOrganizationsOrganizationIdProjectsProjectVersionIdIndexRoute
  '/_auth/dashboard/organizations/$organizationId/settings/inspection/': typeof AuthDashboardOrganizationsOrganizationIdSettingsInspectionIndexRoute
  '/_auth/dashboard/organizations/$organizationId/settings/measuring-instruments/': typeof AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsIndexRoute
  '/_auth/dashboard/organizations/$organizationId/settings/norms/': typeof AuthDashboardOrganizationsOrganizationIdSettingsNormsIndexRoute
  '/_auth/dashboard/organizations/$organizationId/settings/observations/': typeof AuthDashboardOrganizationsOrganizationIdSettingsObservationsIndexRoute
  '/_auth/dashboard/organizations/$organizationId/settings/recommendations/': typeof AuthDashboardOrganizationsOrganizationIdSettingsRecommendationsIndexRoute
  '/_auth/dashboard/organizations/$organizationId/settings/scope12/': typeof AuthDashboardOrganizationsOrganizationIdSettingsScope12IndexRoute
  '/_auth/dashboard/organizations/$organizationId/settings/templates/': typeof AuthDashboardOrganizationsOrganizationIdSettingsTemplatesIndexRoute
  '/_auth/dashboard/organizations/$organizationId/settings/visual-inspections/': typeof AuthDashboardOrganizationsOrganizationIdSettingsVisualInspectionsIndexRoute
  '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRouteWithChildren
  '/_auth/dashboard/organizations/$organizationId/projects/$projectVersionId/documents/': typeof AuthDashboardOrganizationsOrganizationIdProjectsProjectVersionIdDocumentsIndexRoute
  '/_auth/dashboard/organizations/$organizationId/settings/measuring-instruments/$measurementDeviceId/': typeof AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsMeasurementDeviceIdIndexRoute
  '/_auth/dashboard/organizations/$organizationId/settings/scope12/$scopeName/': typeof AuthDashboardOrganizationsOrganizationIdSettingsScope12ScopeNameIndexRoute
  '/_auth/dashboard/organizations/$organizationId/settings/templates/$templateId/': typeof AuthDashboardOrganizationsOrganizationIdSettingsTemplatesTemplateIdIndexRoute
  '/_public/customer/locations/$locationId/electrical/projects/$projectId/': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdIndexRoute
  '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_installations': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsRouteRouteWithChildren
  '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRouteWithChildren
  '/_auth/dashboard/organizations/$organizationId/settings/measuring-instruments/$measurementDeviceId/calibrations/': typeof AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsMeasurementDeviceIdCalibrationsIndexRoute
  '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/distribution-boards/': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewDistributionBoardsIndexRoute
  '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/final-circuit/': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewFinalCircuitIndexRoute
  '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/overview/': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewOverviewIndexRoute
  '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/pv-installations/': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsIndexRoute
  '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/pv-installations/$pvInverterId/': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsPvInverterIdIndexRoute
  '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_installations/distribution-boards/$distributionId/': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsDistributionBoardsDistributionIdIndexRoute
  '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_installations/final-circuit/$circuitId/': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsFinalCircuitCircuitIdIndexRoute
  '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/distribution-boards/$distributionId/notifications/': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdNotificationsIndexRoute
  '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/distribution-boards/$distributionId/observations/': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdObservationsIndexRoute
  '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/final-circuit/$circuitId/notifications/': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdNotificationsIndexRoute
  '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/final-circuit/$circuitId/observations/': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdObservationsIndexRoute
  '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/pv-installations/$pvInverterId/observations/$observationId/': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsPvInverterIdObservationsObservationIdIndexRoute
  '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/distribution-boards/$distributionId/notifications/$notificationId/': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdNotificationsNotificationIdIndexRoute
  '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/distribution-boards/$distributionId/observations/$observationId/': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdObservationsObservationIdIndexRoute
  '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/final-circuit/$circuitId/notifications/$notificationId/': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdNotificationsNotificationIdIndexRoute
  '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/final-circuit/$circuitId/observations/$observationId/': typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdObservationsObservationIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/customer/locations'
    | '/dashboard/organizations'
    | '/logout'
    | '/redirect'
    | '/sso'
    | '/customer'
    | '/dashboard/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/dashboard/account/$userId'
    | '/customer/locations/'
    | '/dashboard/account'
    | '/dashboard/organizations/'
    | '/account/activate'
    | '/dashboard/organizations/$organizationId'
    | '/dashboard/organizations/$organizationId/settings'
    | '/customer/locations/$locationId'
    | '/dashboard/account/$userId/'
    | '/customer/locations/$locationId/air'
    | '/customer/locations/$locationId/atex'
    | '/customer/locations/$locationId/electrical'
    | '/customer/locations/$locationId/legionella'
    | '/customer/locations/$locationId/solar'
    | '/customer/locations/$locationId/water'
    | '/customer/locations/electrical'
    | '/dashboard/account/$userId/profile'
    | '/dashboard/account/$userId/security'
    | '/dashboard/organizations/$organizationId/planning'
    | '/dashboard/organizations/$organizationId/projects'
    | '/dashboard/organizations/$organizationId/requests'
    | '/dashboard/organizations/$organizationId/settings/'
    | '/dashboard/organizations/$organizationId/users'
    | '/customer/locations/$locationId/electrical/projects/$projectId'
    | '/customer/locations/$locationId/electrical/projects'
    | '/customer/locations/$locationId/preview/$moduleType'
    | '/dashboard/organizations/$organizationId/validation'
    | '/dashboard/organizations/$organizationId/projects/$projectVersionId'
    | '/dashboard/organizations/$organizationId/settings/inspection'
    | '/dashboard/organizations/$organizationId/settings/measuring-instruments'
    | '/dashboard/organizations/$organizationId/settings/norms'
    | '/dashboard/organizations/$organizationId/settings/observations'
    | '/dashboard/organizations/$organizationId/settings/recommendations'
    | '/dashboard/organizations/$organizationId/settings/scope12'
    | '/dashboard/organizations/$organizationId/settings/templates'
    | '/dashboard/organizations/$organizationId/settings/visual-inspections'
    | '/dashboard/organizations/$organizationId/projects/$projectVersionId/documents'
    | '/dashboard/organizations/$organizationId/settings/measuring-instruments/$measurementDeviceId'
    | '/dashboard/organizations/$organizationId/settings/scope12/$scopeName'
    | '/dashboard/organizations/$organizationId/settings/templates/$templateId'
    | '/customer/locations/$locationId/electrical/projects/$projectId/'
    | '/dashboard/organizations/$organizationId/settings/measuring-instruments/$measurementDeviceId/calibrations'
    | '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards'
    | '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit'
    | '/customer/locations/$locationId/electrical/projects/$projectId/overview'
    | '/customer/locations/$locationId/electrical/projects/$projectId/pv-installations'
    | '/customer/locations/$locationId/electrical/projects/$projectId/pv-installations/$pvInverterId'
    | '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId'
    | '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId'
    | '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId/notifications'
    | '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId/observations'
    | '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId/notifications'
    | '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId/observations'
    | '/customer/locations/$locationId/electrical/projects/$projectId/pv-installations/$pvInverterId/observations/$observationId'
    | '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId/notifications/$notificationId'
    | '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId/observations/$observationId'
    | '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId/notifications/$notificationId'
    | '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId/observations/$observationId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/logout'
    | '/redirect'
    | '/sso'
    | '/customer'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/customer/locations'
    | '/dashboard/account'
    | '/dashboard/organizations'
    | '/account/activate'
    | '/dashboard/organizations/$organizationId'
    | '/customer/locations/$locationId'
    | '/dashboard/account/$userId'
    | '/customer/locations/$locationId/air'
    | '/customer/locations/$locationId/atex'
    | '/customer/locations/$locationId/electrical'
    | '/customer/locations/$locationId/legionella'
    | '/customer/locations/$locationId/solar'
    | '/customer/locations/$locationId/water'
    | '/customer/locations/electrical'
    | '/dashboard/account/$userId/profile'
    | '/dashboard/account/$userId/security'
    | '/dashboard/organizations/$organizationId/planning'
    | '/dashboard/organizations/$organizationId/projects'
    | '/dashboard/organizations/$organizationId/requests'
    | '/dashboard/organizations/$organizationId/settings'
    | '/dashboard/organizations/$organizationId/users'
    | '/customer/locations/$locationId/electrical/projects'
    | '/customer/locations/$locationId/preview/$moduleType'
    | '/dashboard/organizations/$organizationId/validation'
    | '/dashboard/organizations/$organizationId/projects/$projectVersionId'
    | '/dashboard/organizations/$organizationId/settings/inspection'
    | '/dashboard/organizations/$organizationId/settings/measuring-instruments'
    | '/dashboard/organizations/$organizationId/settings/norms'
    | '/dashboard/organizations/$organizationId/settings/observations'
    | '/dashboard/organizations/$organizationId/settings/recommendations'
    | '/dashboard/organizations/$organizationId/settings/scope12'
    | '/dashboard/organizations/$organizationId/settings/templates'
    | '/dashboard/organizations/$organizationId/settings/visual-inspections'
    | '/customer/locations/$locationId/electrical/projects/$projectId'
    | '/dashboard/organizations/$organizationId/projects/$projectVersionId/documents'
    | '/dashboard/organizations/$organizationId/settings/measuring-instruments/$measurementDeviceId'
    | '/dashboard/organizations/$organizationId/settings/scope12/$scopeName'
    | '/dashboard/organizations/$organizationId/settings/templates/$templateId'
    | '/dashboard/organizations/$organizationId/settings/measuring-instruments/$measurementDeviceId/calibrations'
    | '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards'
    | '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit'
    | '/customer/locations/$locationId/electrical/projects/$projectId/overview'
    | '/customer/locations/$locationId/electrical/projects/$projectId/pv-installations'
    | '/customer/locations/$locationId/electrical/projects/$projectId/pv-installations/$pvInverterId'
    | '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId'
    | '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId'
    | '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId/notifications'
    | '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId/observations'
    | '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId/notifications'
    | '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId/observations'
    | '/customer/locations/$locationId/electrical/projects/$projectId/pv-installations/$pvInverterId/observations/$observationId'
    | '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId/notifications/$notificationId'
    | '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId/observations/$observationId'
    | '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId/notifications/$notificationId'
    | '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId/observations/$observationId'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_unauth'
    | '/_auth/dashboard'
    | '/_auth/customer/locations'
    | '/_auth/dashboard/organizations'
    | '/(shared)/logout/'
    | '/(shared)/redirect/'
    | '/(shared)/sso/'
    | '/_auth/customer/'
    | '/_auth/dashboard/'
    | '/_unauth/forgot-password/'
    | '/_unauth/login/'
    | '/_unauth/reset-password/'
    | '/_auth/customer/locations/_modules'
    | '/_auth/dashboard/account/$userId'
    | '/_auth/customer/locations/'
    | '/_auth/dashboard/account/'
    | '/_auth/dashboard/organizations/'
    | '/_unauth/account/activate/'
    | '/_auth/dashboard/organizations/$organizationId/(admin)'
    | '/_auth/dashboard/organizations/$organizationId/settings'
    | '/_auth/customer/locations/$locationId/'
    | '/_auth/dashboard/account/$userId/'
    | '/_auth/dashboard/organizations/$organizationId/'
    | '/_auth/customer/locations/$locationId/air/'
    | '/_auth/customer/locations/$locationId/atex/'
    | '/_auth/customer/locations/$locationId/electrical/'
    | '/_auth/customer/locations/$locationId/legionella/'
    | '/_auth/customer/locations/$locationId/solar/'
    | '/_auth/customer/locations/$locationId/water/'
    | '/_auth/customer/locations/_modules/electrical/'
    | '/_auth/dashboard/account/$userId/profile/'
    | '/_auth/dashboard/account/$userId/security/'
    | '/_auth/dashboard/organizations/$organizationId/planning/'
    | '/_auth/dashboard/organizations/$organizationId/projects/'
    | '/_auth/dashboard/organizations/$organizationId/requests/'
    | '/_auth/dashboard/organizations/$organizationId/settings/'
    | '/_auth/dashboard/organizations/$organizationId/users/'
    | '/_public/customer/locations/$locationId/electrical/projects/$projectId'
    | '/_auth/customer/locations/$locationId/electrical/projects/'
    | '/_auth/customer/locations/$locationId/preview/$moduleType/'
    | '/_auth/dashboard/organizations/$organizationId/(admin)/validation/'
    | '/_auth/dashboard/organizations/$organizationId/projects/$projectVersionId/'
    | '/_auth/dashboard/organizations/$organizationId/settings/inspection/'
    | '/_auth/dashboard/organizations/$organizationId/settings/measuring-instruments/'
    | '/_auth/dashboard/organizations/$organizationId/settings/norms/'
    | '/_auth/dashboard/organizations/$organizationId/settings/observations/'
    | '/_auth/dashboard/organizations/$organizationId/settings/recommendations/'
    | '/_auth/dashboard/organizations/$organizationId/settings/scope12/'
    | '/_auth/dashboard/organizations/$organizationId/settings/templates/'
    | '/_auth/dashboard/organizations/$organizationId/settings/visual-inspections/'
    | '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview'
    | '/_auth/dashboard/organizations/$organizationId/projects/$projectVersionId/documents/'
    | '/_auth/dashboard/organizations/$organizationId/settings/measuring-instruments/$measurementDeviceId/'
    | '/_auth/dashboard/organizations/$organizationId/settings/scope12/$scopeName/'
    | '/_auth/dashboard/organizations/$organizationId/settings/templates/$templateId/'
    | '/_public/customer/locations/$locationId/electrical/projects/$projectId/'
    | '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_installations'
    | '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports'
    | '/_auth/dashboard/organizations/$organizationId/settings/measuring-instruments/$measurementDeviceId/calibrations/'
    | '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/distribution-boards/'
    | '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/final-circuit/'
    | '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/overview/'
    | '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/pv-installations/'
    | '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/pv-installations/$pvInverterId/'
    | '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_installations/distribution-boards/$distributionId/'
    | '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_installations/final-circuit/$circuitId/'
    | '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/distribution-boards/$distributionId/notifications/'
    | '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/distribution-boards/$distributionId/observations/'
    | '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/final-circuit/$circuitId/notifications/'
    | '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/final-circuit/$circuitId/observations/'
    | '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/pv-installations/$pvInverterId/observations/$observationId/'
    | '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/distribution-boards/$distributionId/notifications/$notificationId/'
    | '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/distribution-boards/$distributionId/observations/$observationId/'
    | '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/final-circuit/$circuitId/notifications/$notificationId/'
    | '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/final-circuit/$circuitId/observations/$observationId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  UnauthRouteRoute: typeof UnauthRouteRouteWithChildren
  sharedLogoutIndexRoute: typeof sharedLogoutIndexRoute
  sharedRedirectIndexRoute: typeof sharedRedirectIndexRoute
  sharedSsoIndexRoute: typeof sharedSsoIndexRoute
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdRouteRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_unauth': {
      id: '/_unauth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof UnauthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/dashboard': {
      id: '/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_unauth/reset-password/': {
      id: '/_unauth/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof UnauthResetPasswordIndexRouteImport
      parentRoute: typeof UnauthRouteRoute
    }
    '/_unauth/login/': {
      id: '/_unauth/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof UnauthLoginIndexRouteImport
      parentRoute: typeof UnauthRouteRoute
    }
    '/_unauth/forgot-password/': {
      id: '/_unauth/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof UnauthForgotPasswordIndexRouteImport
      parentRoute: typeof UnauthRouteRoute
    }
    '/_auth/dashboard/': {
      id: '/_auth/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthDashboardIndexRouteImport
      parentRoute: typeof AuthDashboardRouteRoute
    }
    '/_auth/customer/': {
      id: '/_auth/customer/'
      path: '/customer'
      fullPath: '/customer'
      preLoaderRoute: typeof AuthCustomerIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/(shared)/sso/': {
      id: '/(shared)/sso/'
      path: '/sso'
      fullPath: '/sso'
      preLoaderRoute: typeof sharedSsoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(shared)/redirect/': {
      id: '/(shared)/redirect/'
      path: '/redirect'
      fullPath: '/redirect'
      preLoaderRoute: typeof sharedRedirectIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(shared)/logout/': {
      id: '/(shared)/logout/'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof sharedLogoutIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/dashboard/organizations': {
      id: '/_auth/dashboard/organizations'
      path: '/organizations'
      fullPath: '/dashboard/organizations'
      preLoaderRoute: typeof AuthDashboardOrganizationsRouteRouteImport
      parentRoute: typeof AuthDashboardRouteRoute
    }
    '/_auth/customer/locations': {
      id: '/_auth/customer/locations'
      path: '/customer/locations'
      fullPath: '/customer/locations'
      preLoaderRoute: typeof AuthCustomerLocationsRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_unauth/account/activate/': {
      id: '/_unauth/account/activate/'
      path: '/account/activate'
      fullPath: '/account/activate'
      preLoaderRoute: typeof UnauthAccountActivateIndexRouteImport
      parentRoute: typeof UnauthRouteRoute
    }
    '/_auth/dashboard/organizations/': {
      id: '/_auth/dashboard/organizations/'
      path: '/'
      fullPath: '/dashboard/organizations/'
      preLoaderRoute: typeof AuthDashboardOrganizationsIndexRouteImport
      parentRoute: typeof AuthDashboardOrganizationsRouteRoute
    }
    '/_auth/dashboard/account/': {
      id: '/_auth/dashboard/account/'
      path: '/account'
      fullPath: '/dashboard/account'
      preLoaderRoute: typeof AuthDashboardAccountIndexRouteImport
      parentRoute: typeof AuthDashboardRouteRoute
    }
    '/_auth/customer/locations/': {
      id: '/_auth/customer/locations/'
      path: '/'
      fullPath: '/customer/locations/'
      preLoaderRoute: typeof AuthCustomerLocationsIndexRouteImport
      parentRoute: typeof AuthCustomerLocationsRouteRoute
    }
    '/_auth/dashboard/account/$userId': {
      id: '/_auth/dashboard/account/$userId'
      path: '/account/$userId'
      fullPath: '/dashboard/account/$userId'
      preLoaderRoute: typeof AuthDashboardAccountUserIdRouteRouteImport
      parentRoute: typeof AuthDashboardRouteRoute
    }
    '/_auth/customer/locations/_modules': {
      id: '/_auth/customer/locations/_modules'
      path: ''
      fullPath: '/customer/locations'
      preLoaderRoute: typeof AuthCustomerLocationsModulesRouteRouteImport
      parentRoute: typeof AuthCustomerLocationsRouteRoute
    }
    '/_auth/dashboard/organizations/$organizationId/': {
      id: '/_auth/dashboard/organizations/$organizationId/'
      path: '/$organizationId'
      fullPath: '/dashboard/organizations/$organizationId'
      preLoaderRoute: typeof AuthDashboardOrganizationsOrganizationIdIndexRouteImport
      parentRoute: typeof AuthDashboardOrganizationsRouteRoute
    }
    '/_auth/dashboard/account/$userId/': {
      id: '/_auth/dashboard/account/$userId/'
      path: '/'
      fullPath: '/dashboard/account/$userId/'
      preLoaderRoute: typeof AuthDashboardAccountUserIdIndexRouteImport
      parentRoute: typeof AuthDashboardAccountUserIdRouteRoute
    }
    '/_auth/customer/locations/$locationId/': {
      id: '/_auth/customer/locations/$locationId/'
      path: '/$locationId'
      fullPath: '/customer/locations/$locationId'
      preLoaderRoute: typeof AuthCustomerLocationsLocationIdIndexRouteImport
      parentRoute: typeof AuthCustomerLocationsRouteRoute
    }
    '/_auth/dashboard/organizations/$organizationId/settings': {
      id: '/_auth/dashboard/organizations/$organizationId/settings'
      path: '/$organizationId/settings'
      fullPath: '/dashboard/organizations/$organizationId/settings'
      preLoaderRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsRouteRouteImport
      parentRoute: typeof AuthDashboardOrganizationsRouteRoute
    }
    '/_auth/dashboard/organizations/$organizationId/(admin)': {
      id: '/_auth/dashboard/organizations/$organizationId/(admin)'
      path: '/$organizationId'
      fullPath: '/dashboard/organizations/$organizationId'
      preLoaderRoute: typeof AuthDashboardOrganizationsOrganizationIdadminRouteRouteImport
      parentRoute: typeof AuthDashboardOrganizationsRouteRoute
    }
    '/_auth/dashboard/organizations/$organizationId/users/': {
      id: '/_auth/dashboard/organizations/$organizationId/users/'
      path: '/$organizationId/users'
      fullPath: '/dashboard/organizations/$organizationId/users'
      preLoaderRoute: typeof AuthDashboardOrganizationsOrganizationIdUsersIndexRouteImport
      parentRoute: typeof AuthDashboardOrganizationsRouteRoute
    }
    '/_auth/dashboard/organizations/$organizationId/settings/': {
      id: '/_auth/dashboard/organizations/$organizationId/settings/'
      path: '/'
      fullPath: '/dashboard/organizations/$organizationId/settings/'
      preLoaderRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsIndexRouteImport
      parentRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute
    }
    '/_auth/dashboard/organizations/$organizationId/requests/': {
      id: '/_auth/dashboard/organizations/$organizationId/requests/'
      path: '/$organizationId/requests'
      fullPath: '/dashboard/organizations/$organizationId/requests'
      preLoaderRoute: typeof AuthDashboardOrganizationsOrganizationIdRequestsIndexRouteImport
      parentRoute: typeof AuthDashboardOrganizationsRouteRoute
    }
    '/_auth/dashboard/organizations/$organizationId/projects/': {
      id: '/_auth/dashboard/organizations/$organizationId/projects/'
      path: '/$organizationId/projects'
      fullPath: '/dashboard/organizations/$organizationId/projects'
      preLoaderRoute: typeof AuthDashboardOrganizationsOrganizationIdProjectsIndexRouteImport
      parentRoute: typeof AuthDashboardOrganizationsRouteRoute
    }
    '/_auth/dashboard/organizations/$organizationId/planning/': {
      id: '/_auth/dashboard/organizations/$organizationId/planning/'
      path: '/$organizationId/planning'
      fullPath: '/dashboard/organizations/$organizationId/planning'
      preLoaderRoute: typeof AuthDashboardOrganizationsOrganizationIdPlanningIndexRouteImport
      parentRoute: typeof AuthDashboardOrganizationsRouteRoute
    }
    '/_auth/dashboard/account/$userId/security/': {
      id: '/_auth/dashboard/account/$userId/security/'
      path: '/security'
      fullPath: '/dashboard/account/$userId/security'
      preLoaderRoute: typeof AuthDashboardAccountUserIdSecurityIndexRouteImport
      parentRoute: typeof AuthDashboardAccountUserIdRouteRoute
    }
    '/_auth/dashboard/account/$userId/profile/': {
      id: '/_auth/dashboard/account/$userId/profile/'
      path: '/profile'
      fullPath: '/dashboard/account/$userId/profile'
      preLoaderRoute: typeof AuthDashboardAccountUserIdProfileIndexRouteImport
      parentRoute: typeof AuthDashboardAccountUserIdRouteRoute
    }
    '/_auth/customer/locations/_modules/electrical/': {
      id: '/_auth/customer/locations/_modules/electrical/'
      path: '/electrical'
      fullPath: '/customer/locations/electrical'
      preLoaderRoute: typeof AuthCustomerLocationsModulesElectricalIndexRouteImport
      parentRoute: typeof AuthCustomerLocationsModulesRouteRoute
    }
    '/_auth/customer/locations/$locationId/water/': {
      id: '/_auth/customer/locations/$locationId/water/'
      path: '/$locationId/water'
      fullPath: '/customer/locations/$locationId/water'
      preLoaderRoute: typeof AuthCustomerLocationsLocationIdWaterIndexRouteImport
      parentRoute: typeof AuthCustomerLocationsRouteRoute
    }
    '/_auth/customer/locations/$locationId/solar/': {
      id: '/_auth/customer/locations/$locationId/solar/'
      path: '/$locationId/solar'
      fullPath: '/customer/locations/$locationId/solar'
      preLoaderRoute: typeof AuthCustomerLocationsLocationIdSolarIndexRouteImport
      parentRoute: typeof AuthCustomerLocationsRouteRoute
    }
    '/_auth/customer/locations/$locationId/legionella/': {
      id: '/_auth/customer/locations/$locationId/legionella/'
      path: '/$locationId/legionella'
      fullPath: '/customer/locations/$locationId/legionella'
      preLoaderRoute: typeof AuthCustomerLocationsLocationIdLegionellaIndexRouteImport
      parentRoute: typeof AuthCustomerLocationsRouteRoute
    }
    '/_auth/customer/locations/$locationId/electrical/': {
      id: '/_auth/customer/locations/$locationId/electrical/'
      path: '/$locationId/electrical'
      fullPath: '/customer/locations/$locationId/electrical'
      preLoaderRoute: typeof AuthCustomerLocationsLocationIdElectricalIndexRouteImport
      parentRoute: typeof AuthCustomerLocationsRouteRoute
    }
    '/_auth/customer/locations/$locationId/atex/': {
      id: '/_auth/customer/locations/$locationId/atex/'
      path: '/$locationId/atex'
      fullPath: '/customer/locations/$locationId/atex'
      preLoaderRoute: typeof AuthCustomerLocationsLocationIdAtexIndexRouteImport
      parentRoute: typeof AuthCustomerLocationsRouteRoute
    }
    '/_auth/customer/locations/$locationId/air/': {
      id: '/_auth/customer/locations/$locationId/air/'
      path: '/$locationId/air'
      fullPath: '/customer/locations/$locationId/air'
      preLoaderRoute: typeof AuthCustomerLocationsLocationIdAirIndexRouteImport
      parentRoute: typeof AuthCustomerLocationsRouteRoute
    }
    '/_auth/dashboard/organizations/$organizationId/settings/visual-inspections/': {
      id: '/_auth/dashboard/organizations/$organizationId/settings/visual-inspections/'
      path: '/visual-inspections'
      fullPath: '/dashboard/organizations/$organizationId/settings/visual-inspections'
      preLoaderRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsVisualInspectionsIndexRouteImport
      parentRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute
    }
    '/_auth/dashboard/organizations/$organizationId/settings/templates/': {
      id: '/_auth/dashboard/organizations/$organizationId/settings/templates/'
      path: '/templates'
      fullPath: '/dashboard/organizations/$organizationId/settings/templates'
      preLoaderRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsTemplatesIndexRouteImport
      parentRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute
    }
    '/_auth/dashboard/organizations/$organizationId/settings/scope12/': {
      id: '/_auth/dashboard/organizations/$organizationId/settings/scope12/'
      path: '/scope12'
      fullPath: '/dashboard/organizations/$organizationId/settings/scope12'
      preLoaderRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsScope12IndexRouteImport
      parentRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute
    }
    '/_auth/dashboard/organizations/$organizationId/settings/recommendations/': {
      id: '/_auth/dashboard/organizations/$organizationId/settings/recommendations/'
      path: '/recommendations'
      fullPath: '/dashboard/organizations/$organizationId/settings/recommendations'
      preLoaderRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsRecommendationsIndexRouteImport
      parentRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute
    }
    '/_auth/dashboard/organizations/$organizationId/settings/observations/': {
      id: '/_auth/dashboard/organizations/$organizationId/settings/observations/'
      path: '/observations'
      fullPath: '/dashboard/organizations/$organizationId/settings/observations'
      preLoaderRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsObservationsIndexRouteImport
      parentRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute
    }
    '/_auth/dashboard/organizations/$organizationId/settings/norms/': {
      id: '/_auth/dashboard/organizations/$organizationId/settings/norms/'
      path: '/norms'
      fullPath: '/dashboard/organizations/$organizationId/settings/norms'
      preLoaderRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsNormsIndexRouteImport
      parentRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute
    }
    '/_auth/dashboard/organizations/$organizationId/settings/measuring-instruments/': {
      id: '/_auth/dashboard/organizations/$organizationId/settings/measuring-instruments/'
      path: '/measuring-instruments'
      fullPath: '/dashboard/organizations/$organizationId/settings/measuring-instruments'
      preLoaderRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsIndexRouteImport
      parentRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute
    }
    '/_auth/dashboard/organizations/$organizationId/settings/inspection/': {
      id: '/_auth/dashboard/organizations/$organizationId/settings/inspection/'
      path: '/inspection'
      fullPath: '/dashboard/organizations/$organizationId/settings/inspection'
      preLoaderRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsInspectionIndexRouteImport
      parentRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute
    }
    '/_auth/dashboard/organizations/$organizationId/projects/$projectVersionId/': {
      id: '/_auth/dashboard/organizations/$organizationId/projects/$projectVersionId/'
      path: '/$organizationId/projects/$projectVersionId'
      fullPath: '/dashboard/organizations/$organizationId/projects/$projectVersionId'
      preLoaderRoute: typeof AuthDashboardOrganizationsOrganizationIdProjectsProjectVersionIdIndexRouteImport
      parentRoute: typeof AuthDashboardOrganizationsRouteRoute
    }
    '/_auth/dashboard/organizations/$organizationId/(admin)/validation/': {
      id: '/_auth/dashboard/organizations/$organizationId/(admin)/validation/'
      path: '/validation'
      fullPath: '/dashboard/organizations/$organizationId/validation'
      preLoaderRoute: typeof AuthDashboardOrganizationsOrganizationIdadminValidationIndexRouteImport
      parentRoute: typeof AuthDashboardOrganizationsOrganizationIdadminRouteRoute
    }
    '/_auth/customer/locations/$locationId/preview/$moduleType/': {
      id: '/_auth/customer/locations/$locationId/preview/$moduleType/'
      path: '/$locationId/preview/$moduleType'
      fullPath: '/customer/locations/$locationId/preview/$moduleType'
      preLoaderRoute: typeof AuthCustomerLocationsLocationIdPreviewModuleTypeIndexRouteImport
      parentRoute: typeof AuthCustomerLocationsRouteRoute
    }
    '/_auth/customer/locations/$locationId/electrical/projects/': {
      id: '/_auth/customer/locations/$locationId/electrical/projects/'
      path: '/$locationId/electrical/projects'
      fullPath: '/customer/locations/$locationId/electrical/projects'
      preLoaderRoute: typeof AuthCustomerLocationsLocationIdElectricalProjectsIndexRouteImport
      parentRoute: typeof AuthCustomerLocationsRouteRoute
    }
    '/_public/customer/locations/$locationId/electrical/projects/$projectId': {
      id: '/_public/customer/locations/$locationId/electrical/projects/$projectId'
      path: '/customer/locations/$locationId/electrical/projects/$projectId'
      fullPath: '/customer/locations/$locationId/electrical/projects/$projectId'
      preLoaderRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/customer/locations/$locationId/electrical/projects/$projectId/': {
      id: '/_public/customer/locations/$locationId/electrical/projects/$projectId/'
      path: '/'
      fullPath: '/customer/locations/$locationId/electrical/projects/$projectId/'
      preLoaderRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdIndexRouteImport
      parentRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdRouteRoute
    }
    '/_auth/dashboard/organizations/$organizationId/settings/templates/$templateId/': {
      id: '/_auth/dashboard/organizations/$organizationId/settings/templates/$templateId/'
      path: '/templates/$templateId'
      fullPath: '/dashboard/organizations/$organizationId/settings/templates/$templateId'
      preLoaderRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsTemplatesTemplateIdIndexRouteImport
      parentRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute
    }
    '/_auth/dashboard/organizations/$organizationId/settings/scope12/$scopeName/': {
      id: '/_auth/dashboard/organizations/$organizationId/settings/scope12/$scopeName/'
      path: '/scope12/$scopeName'
      fullPath: '/dashboard/organizations/$organizationId/settings/scope12/$scopeName'
      preLoaderRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsScope12ScopeNameIndexRouteImport
      parentRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute
    }
    '/_auth/dashboard/organizations/$organizationId/settings/measuring-instruments/$measurementDeviceId/': {
      id: '/_auth/dashboard/organizations/$organizationId/settings/measuring-instruments/$measurementDeviceId/'
      path: '/measuring-instruments/$measurementDeviceId'
      fullPath: '/dashboard/organizations/$organizationId/settings/measuring-instruments/$measurementDeviceId'
      preLoaderRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsMeasurementDeviceIdIndexRouteImport
      parentRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute
    }
    '/_auth/dashboard/organizations/$organizationId/projects/$projectVersionId/documents/': {
      id: '/_auth/dashboard/organizations/$organizationId/projects/$projectVersionId/documents/'
      path: '/$organizationId/projects/$projectVersionId/documents'
      fullPath: '/dashboard/organizations/$organizationId/projects/$projectVersionId/documents'
      preLoaderRoute: typeof AuthDashboardOrganizationsOrganizationIdProjectsProjectVersionIdDocumentsIndexRouteImport
      parentRoute: typeof AuthDashboardOrganizationsRouteRoute
    }
    '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview': {
      id: '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview'
      path: ''
      fullPath: '/customer/locations/$locationId/electrical/projects/$projectId'
      preLoaderRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRouteImport
      parentRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdRouteRoute
    }
    '/_auth/dashboard/organizations/$organizationId/settings/measuring-instruments/$measurementDeviceId/calibrations/': {
      id: '/_auth/dashboard/organizations/$organizationId/settings/measuring-instruments/$measurementDeviceId/calibrations/'
      path: '/measuring-instruments/$measurementDeviceId/calibrations'
      fullPath: '/dashboard/organizations/$organizationId/settings/measuring-instruments/$measurementDeviceId/calibrations'
      preLoaderRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsMeasurementDeviceIdCalibrationsIndexRouteImport
      parentRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute
    }
    '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports': {
      id: '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports'
      path: ''
      fullPath: '/customer/locations/$locationId/electrical/projects/$projectId'
      preLoaderRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRouteImport
      parentRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdRouteRoute
    }
    '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_installations': {
      id: '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_installations'
      path: ''
      fullPath: '/customer/locations/$locationId/electrical/projects/$projectId'
      preLoaderRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsRouteRouteImport
      parentRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdRouteRoute
    }
    '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/pv-installations/': {
      id: '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/pv-installations/'
      path: '/pv-installations'
      fullPath: '/customer/locations/$locationId/electrical/projects/$projectId/pv-installations'
      preLoaderRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsIndexRouteImport
      parentRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRoute
    }
    '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/overview/': {
      id: '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/overview/'
      path: '/overview'
      fullPath: '/customer/locations/$locationId/electrical/projects/$projectId/overview'
      preLoaderRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewOverviewIndexRouteImport
      parentRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRoute
    }
    '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/final-circuit/': {
      id: '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/final-circuit/'
      path: '/final-circuit'
      fullPath: '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit'
      preLoaderRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewFinalCircuitIndexRouteImport
      parentRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRoute
    }
    '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/distribution-boards/': {
      id: '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/distribution-boards/'
      path: '/distribution-boards'
      fullPath: '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards'
      preLoaderRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewDistributionBoardsIndexRouteImport
      parentRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRoute
    }
    '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/pv-installations/$pvInverterId/': {
      id: '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/pv-installations/$pvInverterId/'
      path: '/pv-installations/$pvInverterId'
      fullPath: '/customer/locations/$locationId/electrical/projects/$projectId/pv-installations/$pvInverterId'
      preLoaderRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsPvInverterIdIndexRouteImport
      parentRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRoute
    }
    '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_installations/final-circuit/$circuitId/': {
      id: '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_installations/final-circuit/$circuitId/'
      path: '/final-circuit/$circuitId'
      fullPath: '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId'
      preLoaderRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsFinalCircuitCircuitIdIndexRouteImport
      parentRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsRouteRoute
    }
    '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_installations/distribution-boards/$distributionId/': {
      id: '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_installations/distribution-boards/$distributionId/'
      path: '/distribution-boards/$distributionId'
      fullPath: '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId'
      preLoaderRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsDistributionBoardsDistributionIdIndexRouteImport
      parentRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsRouteRoute
    }
    '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/pv-installations/$pvInverterId/observations/$observationId/': {
      id: '/_public/customer/locations/$locationId/electrical/projects/$projectId/_overview/pv-installations/$pvInverterId/observations/$observationId/'
      path: '/pv-installations/$pvInverterId/observations/$observationId'
      fullPath: '/customer/locations/$locationId/electrical/projects/$projectId/pv-installations/$pvInverterId/observations/$observationId'
      preLoaderRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsPvInverterIdObservationsObservationIdIndexRouteImport
      parentRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRoute
    }
    '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/final-circuit/$circuitId/observations/': {
      id: '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/final-circuit/$circuitId/observations/'
      path: '/final-circuit/$circuitId/observations'
      fullPath: '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId/observations'
      preLoaderRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdObservationsIndexRouteImport
      parentRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRoute
    }
    '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/final-circuit/$circuitId/notifications/': {
      id: '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/final-circuit/$circuitId/notifications/'
      path: '/final-circuit/$circuitId/notifications'
      fullPath: '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId/notifications'
      preLoaderRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdNotificationsIndexRouteImport
      parentRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRoute
    }
    '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/distribution-boards/$distributionId/observations/': {
      id: '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/distribution-boards/$distributionId/observations/'
      path: '/distribution-boards/$distributionId/observations'
      fullPath: '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId/observations'
      preLoaderRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdObservationsIndexRouteImport
      parentRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRoute
    }
    '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/distribution-boards/$distributionId/notifications/': {
      id: '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/distribution-boards/$distributionId/notifications/'
      path: '/distribution-boards/$distributionId/notifications'
      fullPath: '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId/notifications'
      preLoaderRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdNotificationsIndexRouteImport
      parentRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRoute
    }
    '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/final-circuit/$circuitId/observations/$observationId/': {
      id: '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/final-circuit/$circuitId/observations/$observationId/'
      path: '/final-circuit/$circuitId/observations/$observationId'
      fullPath: '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId/observations/$observationId'
      preLoaderRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdObservationsObservationIdIndexRouteImport
      parentRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRoute
    }
    '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/final-circuit/$circuitId/notifications/$notificationId/': {
      id: '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/final-circuit/$circuitId/notifications/$notificationId/'
      path: '/final-circuit/$circuitId/notifications/$notificationId'
      fullPath: '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId/notifications/$notificationId'
      preLoaderRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdNotificationsNotificationIdIndexRouteImport
      parentRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRoute
    }
    '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/distribution-boards/$distributionId/observations/$observationId/': {
      id: '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/distribution-boards/$distributionId/observations/$observationId/'
      path: '/distribution-boards/$distributionId/observations/$observationId'
      fullPath: '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId/observations/$observationId'
      preLoaderRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdObservationsObservationIdIndexRouteImport
      parentRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRoute
    }
    '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/distribution-boards/$distributionId/notifications/$notificationId/': {
      id: '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/distribution-boards/$distributionId/notifications/$notificationId/'
      path: '/distribution-boards/$distributionId/notifications/$notificationId'
      fullPath: '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId/notifications/$notificationId'
      preLoaderRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdNotificationsNotificationIdIndexRouteImport
      parentRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRoute
    }
  }
}

interface AuthDashboardOrganizationsOrganizationIdadminRouteRouteChildren {
  AuthDashboardOrganizationsOrganizationIdadminValidationIndexRoute: typeof AuthDashboardOrganizationsOrganizationIdadminValidationIndexRoute
}

const AuthDashboardOrganizationsOrganizationIdadminRouteRouteChildren: AuthDashboardOrganizationsOrganizationIdadminRouteRouteChildren =
  {
    AuthDashboardOrganizationsOrganizationIdadminValidationIndexRoute:
      AuthDashboardOrganizationsOrganizationIdadminValidationIndexRoute,
  }

const AuthDashboardOrganizationsOrganizationIdadminRouteRouteWithChildren =
  AuthDashboardOrganizationsOrganizationIdadminRouteRoute._addFileChildren(
    AuthDashboardOrganizationsOrganizationIdadminRouteRouteChildren,
  )

interface AuthDashboardOrganizationsOrganizationIdSettingsRouteRouteChildren {
  AuthDashboardOrganizationsOrganizationIdSettingsIndexRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsIndexRoute
  AuthDashboardOrganizationsOrganizationIdSettingsInspectionIndexRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsInspectionIndexRoute
  AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsIndexRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsIndexRoute
  AuthDashboardOrganizationsOrganizationIdSettingsNormsIndexRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsNormsIndexRoute
  AuthDashboardOrganizationsOrganizationIdSettingsObservationsIndexRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsObservationsIndexRoute
  AuthDashboardOrganizationsOrganizationIdSettingsRecommendationsIndexRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsRecommendationsIndexRoute
  AuthDashboardOrganizationsOrganizationIdSettingsScope12IndexRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsScope12IndexRoute
  AuthDashboardOrganizationsOrganizationIdSettingsTemplatesIndexRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsTemplatesIndexRoute
  AuthDashboardOrganizationsOrganizationIdSettingsVisualInspectionsIndexRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsVisualInspectionsIndexRoute
  AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsMeasurementDeviceIdIndexRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsMeasurementDeviceIdIndexRoute
  AuthDashboardOrganizationsOrganizationIdSettingsScope12ScopeNameIndexRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsScope12ScopeNameIndexRoute
  AuthDashboardOrganizationsOrganizationIdSettingsTemplatesTemplateIdIndexRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsTemplatesTemplateIdIndexRoute
  AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsMeasurementDeviceIdCalibrationsIndexRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsMeasurementDeviceIdCalibrationsIndexRoute
}

const AuthDashboardOrganizationsOrganizationIdSettingsRouteRouteChildren: AuthDashboardOrganizationsOrganizationIdSettingsRouteRouteChildren =
  {
    AuthDashboardOrganizationsOrganizationIdSettingsIndexRoute:
      AuthDashboardOrganizationsOrganizationIdSettingsIndexRoute,
    AuthDashboardOrganizationsOrganizationIdSettingsInspectionIndexRoute:
      AuthDashboardOrganizationsOrganizationIdSettingsInspectionIndexRoute,
    AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsIndexRoute:
      AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsIndexRoute,
    AuthDashboardOrganizationsOrganizationIdSettingsNormsIndexRoute:
      AuthDashboardOrganizationsOrganizationIdSettingsNormsIndexRoute,
    AuthDashboardOrganizationsOrganizationIdSettingsObservationsIndexRoute:
      AuthDashboardOrganizationsOrganizationIdSettingsObservationsIndexRoute,
    AuthDashboardOrganizationsOrganizationIdSettingsRecommendationsIndexRoute:
      AuthDashboardOrganizationsOrganizationIdSettingsRecommendationsIndexRoute,
    AuthDashboardOrganizationsOrganizationIdSettingsScope12IndexRoute:
      AuthDashboardOrganizationsOrganizationIdSettingsScope12IndexRoute,
    AuthDashboardOrganizationsOrganizationIdSettingsTemplatesIndexRoute:
      AuthDashboardOrganizationsOrganizationIdSettingsTemplatesIndexRoute,
    AuthDashboardOrganizationsOrganizationIdSettingsVisualInspectionsIndexRoute:
      AuthDashboardOrganizationsOrganizationIdSettingsVisualInspectionsIndexRoute,
    AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsMeasurementDeviceIdIndexRoute:
      AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsMeasurementDeviceIdIndexRoute,
    AuthDashboardOrganizationsOrganizationIdSettingsScope12ScopeNameIndexRoute:
      AuthDashboardOrganizationsOrganizationIdSettingsScope12ScopeNameIndexRoute,
    AuthDashboardOrganizationsOrganizationIdSettingsTemplatesTemplateIdIndexRoute:
      AuthDashboardOrganizationsOrganizationIdSettingsTemplatesTemplateIdIndexRoute,
    AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsMeasurementDeviceIdCalibrationsIndexRoute:
      AuthDashboardOrganizationsOrganizationIdSettingsMeasuringInstrumentsMeasurementDeviceIdCalibrationsIndexRoute,
  }

const AuthDashboardOrganizationsOrganizationIdSettingsRouteRouteWithChildren =
  AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute._addFileChildren(
    AuthDashboardOrganizationsOrganizationIdSettingsRouteRouteChildren,
  )

interface AuthDashboardOrganizationsRouteRouteChildren {
  AuthDashboardOrganizationsIndexRoute: typeof AuthDashboardOrganizationsIndexRoute
  AuthDashboardOrganizationsOrganizationIdadminRouteRoute: typeof AuthDashboardOrganizationsOrganizationIdadminRouteRouteWithChildren
  AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute: typeof AuthDashboardOrganizationsOrganizationIdSettingsRouteRouteWithChildren
  AuthDashboardOrganizationsOrganizationIdIndexRoute: typeof AuthDashboardOrganizationsOrganizationIdIndexRoute
  AuthDashboardOrganizationsOrganizationIdPlanningIndexRoute: typeof AuthDashboardOrganizationsOrganizationIdPlanningIndexRoute
  AuthDashboardOrganizationsOrganizationIdProjectsIndexRoute: typeof AuthDashboardOrganizationsOrganizationIdProjectsIndexRoute
  AuthDashboardOrganizationsOrganizationIdRequestsIndexRoute: typeof AuthDashboardOrganizationsOrganizationIdRequestsIndexRoute
  AuthDashboardOrganizationsOrganizationIdUsersIndexRoute: typeof AuthDashboardOrganizationsOrganizationIdUsersIndexRoute
  AuthDashboardOrganizationsOrganizationIdProjectsProjectVersionIdIndexRoute: typeof AuthDashboardOrganizationsOrganizationIdProjectsProjectVersionIdIndexRoute
  AuthDashboardOrganizationsOrganizationIdProjectsProjectVersionIdDocumentsIndexRoute: typeof AuthDashboardOrganizationsOrganizationIdProjectsProjectVersionIdDocumentsIndexRoute
}

const AuthDashboardOrganizationsRouteRouteChildren: AuthDashboardOrganizationsRouteRouteChildren =
  {
    AuthDashboardOrganizationsIndexRoute: AuthDashboardOrganizationsIndexRoute,
    AuthDashboardOrganizationsOrganizationIdadminRouteRoute:
      AuthDashboardOrganizationsOrganizationIdadminRouteRouteWithChildren,
    AuthDashboardOrganizationsOrganizationIdSettingsRouteRoute:
      AuthDashboardOrganizationsOrganizationIdSettingsRouteRouteWithChildren,
    AuthDashboardOrganizationsOrganizationIdIndexRoute:
      AuthDashboardOrganizationsOrganizationIdIndexRoute,
    AuthDashboardOrganizationsOrganizationIdPlanningIndexRoute:
      AuthDashboardOrganizationsOrganizationIdPlanningIndexRoute,
    AuthDashboardOrganizationsOrganizationIdProjectsIndexRoute:
      AuthDashboardOrganizationsOrganizationIdProjectsIndexRoute,
    AuthDashboardOrganizationsOrganizationIdRequestsIndexRoute:
      AuthDashboardOrganizationsOrganizationIdRequestsIndexRoute,
    AuthDashboardOrganizationsOrganizationIdUsersIndexRoute:
      AuthDashboardOrganizationsOrganizationIdUsersIndexRoute,
    AuthDashboardOrganizationsOrganizationIdProjectsProjectVersionIdIndexRoute:
      AuthDashboardOrganizationsOrganizationIdProjectsProjectVersionIdIndexRoute,
    AuthDashboardOrganizationsOrganizationIdProjectsProjectVersionIdDocumentsIndexRoute:
      AuthDashboardOrganizationsOrganizationIdProjectsProjectVersionIdDocumentsIndexRoute,
  }

const AuthDashboardOrganizationsRouteRouteWithChildren =
  AuthDashboardOrganizationsRouteRoute._addFileChildren(
    AuthDashboardOrganizationsRouteRouteChildren,
  )

interface AuthDashboardAccountUserIdRouteRouteChildren {
  AuthDashboardAccountUserIdIndexRoute: typeof AuthDashboardAccountUserIdIndexRoute
  AuthDashboardAccountUserIdProfileIndexRoute: typeof AuthDashboardAccountUserIdProfileIndexRoute
  AuthDashboardAccountUserIdSecurityIndexRoute: typeof AuthDashboardAccountUserIdSecurityIndexRoute
}

const AuthDashboardAccountUserIdRouteRouteChildren: AuthDashboardAccountUserIdRouteRouteChildren =
  {
    AuthDashboardAccountUserIdIndexRoute: AuthDashboardAccountUserIdIndexRoute,
    AuthDashboardAccountUserIdProfileIndexRoute:
      AuthDashboardAccountUserIdProfileIndexRoute,
    AuthDashboardAccountUserIdSecurityIndexRoute:
      AuthDashboardAccountUserIdSecurityIndexRoute,
  }

const AuthDashboardAccountUserIdRouteRouteWithChildren =
  AuthDashboardAccountUserIdRouteRoute._addFileChildren(
    AuthDashboardAccountUserIdRouteRouteChildren,
  )

interface AuthDashboardRouteRouteChildren {
  AuthDashboardOrganizationsRouteRoute: typeof AuthDashboardOrganizationsRouteRouteWithChildren
  AuthDashboardIndexRoute: typeof AuthDashboardIndexRoute
  AuthDashboardAccountUserIdRouteRoute: typeof AuthDashboardAccountUserIdRouteRouteWithChildren
  AuthDashboardAccountIndexRoute: typeof AuthDashboardAccountIndexRoute
}

const AuthDashboardRouteRouteChildren: AuthDashboardRouteRouteChildren = {
  AuthDashboardOrganizationsRouteRoute:
    AuthDashboardOrganizationsRouteRouteWithChildren,
  AuthDashboardIndexRoute: AuthDashboardIndexRoute,
  AuthDashboardAccountUserIdRouteRoute:
    AuthDashboardAccountUserIdRouteRouteWithChildren,
  AuthDashboardAccountIndexRoute: AuthDashboardAccountIndexRoute,
}

const AuthDashboardRouteRouteWithChildren =
  AuthDashboardRouteRoute._addFileChildren(AuthDashboardRouteRouteChildren)

interface AuthCustomerLocationsModulesRouteRouteChildren {
  AuthCustomerLocationsModulesElectricalIndexRoute: typeof AuthCustomerLocationsModulesElectricalIndexRoute
}

const AuthCustomerLocationsModulesRouteRouteChildren: AuthCustomerLocationsModulesRouteRouteChildren =
  {
    AuthCustomerLocationsModulesElectricalIndexRoute:
      AuthCustomerLocationsModulesElectricalIndexRoute,
  }

const AuthCustomerLocationsModulesRouteRouteWithChildren =
  AuthCustomerLocationsModulesRouteRoute._addFileChildren(
    AuthCustomerLocationsModulesRouteRouteChildren,
  )

interface AuthCustomerLocationsRouteRouteChildren {
  AuthCustomerLocationsModulesRouteRoute: typeof AuthCustomerLocationsModulesRouteRouteWithChildren
  AuthCustomerLocationsIndexRoute: typeof AuthCustomerLocationsIndexRoute
  AuthCustomerLocationsLocationIdIndexRoute: typeof AuthCustomerLocationsLocationIdIndexRoute
  AuthCustomerLocationsLocationIdAirIndexRoute: typeof AuthCustomerLocationsLocationIdAirIndexRoute
  AuthCustomerLocationsLocationIdAtexIndexRoute: typeof AuthCustomerLocationsLocationIdAtexIndexRoute
  AuthCustomerLocationsLocationIdElectricalIndexRoute: typeof AuthCustomerLocationsLocationIdElectricalIndexRoute
  AuthCustomerLocationsLocationIdLegionellaIndexRoute: typeof AuthCustomerLocationsLocationIdLegionellaIndexRoute
  AuthCustomerLocationsLocationIdSolarIndexRoute: typeof AuthCustomerLocationsLocationIdSolarIndexRoute
  AuthCustomerLocationsLocationIdWaterIndexRoute: typeof AuthCustomerLocationsLocationIdWaterIndexRoute
  AuthCustomerLocationsLocationIdElectricalProjectsIndexRoute: typeof AuthCustomerLocationsLocationIdElectricalProjectsIndexRoute
  AuthCustomerLocationsLocationIdPreviewModuleTypeIndexRoute: typeof AuthCustomerLocationsLocationIdPreviewModuleTypeIndexRoute
}

const AuthCustomerLocationsRouteRouteChildren: AuthCustomerLocationsRouteRouteChildren =
  {
    AuthCustomerLocationsModulesRouteRoute:
      AuthCustomerLocationsModulesRouteRouteWithChildren,
    AuthCustomerLocationsIndexRoute: AuthCustomerLocationsIndexRoute,
    AuthCustomerLocationsLocationIdIndexRoute:
      AuthCustomerLocationsLocationIdIndexRoute,
    AuthCustomerLocationsLocationIdAirIndexRoute:
      AuthCustomerLocationsLocationIdAirIndexRoute,
    AuthCustomerLocationsLocationIdAtexIndexRoute:
      AuthCustomerLocationsLocationIdAtexIndexRoute,
    AuthCustomerLocationsLocationIdElectricalIndexRoute:
      AuthCustomerLocationsLocationIdElectricalIndexRoute,
    AuthCustomerLocationsLocationIdLegionellaIndexRoute:
      AuthCustomerLocationsLocationIdLegionellaIndexRoute,
    AuthCustomerLocationsLocationIdSolarIndexRoute:
      AuthCustomerLocationsLocationIdSolarIndexRoute,
    AuthCustomerLocationsLocationIdWaterIndexRoute:
      AuthCustomerLocationsLocationIdWaterIndexRoute,
    AuthCustomerLocationsLocationIdElectricalProjectsIndexRoute:
      AuthCustomerLocationsLocationIdElectricalProjectsIndexRoute,
    AuthCustomerLocationsLocationIdPreviewModuleTypeIndexRoute:
      AuthCustomerLocationsLocationIdPreviewModuleTypeIndexRoute,
  }

const AuthCustomerLocationsRouteRouteWithChildren =
  AuthCustomerLocationsRouteRoute._addFileChildren(
    AuthCustomerLocationsRouteRouteChildren,
  )

interface AuthRouteRouteChildren {
  AuthDashboardRouteRoute: typeof AuthDashboardRouteRouteWithChildren
  AuthCustomerLocationsRouteRoute: typeof AuthCustomerLocationsRouteRouteWithChildren
  AuthCustomerIndexRoute: typeof AuthCustomerIndexRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthDashboardRouteRoute: AuthDashboardRouteRouteWithChildren,
  AuthCustomerLocationsRouteRoute: AuthCustomerLocationsRouteRouteWithChildren,
  AuthCustomerIndexRoute: AuthCustomerIndexRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface UnauthRouteRouteChildren {
  UnauthForgotPasswordIndexRoute: typeof UnauthForgotPasswordIndexRoute
  UnauthLoginIndexRoute: typeof UnauthLoginIndexRoute
  UnauthResetPasswordIndexRoute: typeof UnauthResetPasswordIndexRoute
  UnauthAccountActivateIndexRoute: typeof UnauthAccountActivateIndexRoute
}

const UnauthRouteRouteChildren: UnauthRouteRouteChildren = {
  UnauthForgotPasswordIndexRoute: UnauthForgotPasswordIndexRoute,
  UnauthLoginIndexRoute: UnauthLoginIndexRoute,
  UnauthResetPasswordIndexRoute: UnauthResetPasswordIndexRoute,
  UnauthAccountActivateIndexRoute: UnauthAccountActivateIndexRoute,
}

const UnauthRouteRouteWithChildren = UnauthRouteRoute._addFileChildren(
  UnauthRouteRouteChildren,
)

interface PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRouteChildren {
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewDistributionBoardsIndexRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewDistributionBoardsIndexRoute
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewFinalCircuitIndexRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewFinalCircuitIndexRoute
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewOverviewIndexRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewOverviewIndexRoute
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsIndexRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsIndexRoute
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsPvInverterIdIndexRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsPvInverterIdIndexRoute
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsPvInverterIdObservationsObservationIdIndexRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsPvInverterIdObservationsObservationIdIndexRoute
}

const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRouteChildren: PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRouteChildren =
  {
    PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewDistributionBoardsIndexRoute:
      PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewDistributionBoardsIndexRoute,
    PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewFinalCircuitIndexRoute:
      PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewFinalCircuitIndexRoute,
    PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewOverviewIndexRoute:
      PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewOverviewIndexRoute,
    PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsIndexRoute:
      PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsIndexRoute,
    PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsPvInverterIdIndexRoute:
      PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsPvInverterIdIndexRoute,
    PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsPvInverterIdObservationsObservationIdIndexRoute:
      PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewPvInstallationsPvInverterIdObservationsObservationIdIndexRoute,
  }

const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRouteWithChildren =
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRoute._addFileChildren(
    PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRouteChildren,
  )

interface PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsRouteRouteChildren {
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsDistributionBoardsDistributionIdIndexRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsDistributionBoardsDistributionIdIndexRoute
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsFinalCircuitCircuitIdIndexRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsFinalCircuitCircuitIdIndexRoute
}

const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsRouteRouteChildren: PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsRouteRouteChildren =
  {
    PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsDistributionBoardsDistributionIdIndexRoute:
      PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsDistributionBoardsDistributionIdIndexRoute,
    PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsFinalCircuitCircuitIdIndexRoute:
      PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsFinalCircuitCircuitIdIndexRoute,
  }

const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsRouteRouteWithChildren =
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsRouteRoute._addFileChildren(
    PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsRouteRouteChildren,
  )

interface PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRouteChildren {
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdNotificationsIndexRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdNotificationsIndexRoute
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdObservationsIndexRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdObservationsIndexRoute
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdNotificationsIndexRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdNotificationsIndexRoute
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdObservationsIndexRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdObservationsIndexRoute
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdNotificationsNotificationIdIndexRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdNotificationsNotificationIdIndexRoute
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdObservationsObservationIdIndexRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdObservationsObservationIdIndexRoute
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdNotificationsNotificationIdIndexRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdNotificationsNotificationIdIndexRoute
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdObservationsObservationIdIndexRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdObservationsObservationIdIndexRoute
}

const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRouteChildren: PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRouteChildren =
  {
    PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdNotificationsIndexRoute:
      PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdNotificationsIndexRoute,
    PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdObservationsIndexRoute:
      PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdObservationsIndexRoute,
    PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdNotificationsIndexRoute:
      PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdNotificationsIndexRoute,
    PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdObservationsIndexRoute:
      PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdObservationsIndexRoute,
    PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdNotificationsNotificationIdIndexRoute:
      PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdNotificationsNotificationIdIndexRoute,
    PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdObservationsObservationIdIndexRoute:
      PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsDistributionBoardsDistributionIdObservationsObservationIdIndexRoute,
    PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdNotificationsNotificationIdIndexRoute:
      PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdNotificationsNotificationIdIndexRoute,
    PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdObservationsObservationIdIndexRoute:
      PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsFinalCircuitCircuitIdObservationsObservationIdIndexRoute,
  }

const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRouteWithChildren =
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRoute._addFileChildren(
    PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRouteChildren,
  )

interface PublicCustomerLocationsLocationIdElectricalProjectsProjectIdRouteRouteChildren {
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRouteWithChildren
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdIndexRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdIndexRoute
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsRouteRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsRouteRouteWithChildren
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRoute: typeof PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRouteWithChildren
}

const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdRouteRouteChildren: PublicCustomerLocationsLocationIdElectricalProjectsProjectIdRouteRouteChildren =
  {
    PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRoute:
      PublicCustomerLocationsLocationIdElectricalProjectsProjectIdOverviewRouteRouteWithChildren,
    PublicCustomerLocationsLocationIdElectricalProjectsProjectIdIndexRoute:
      PublicCustomerLocationsLocationIdElectricalProjectsProjectIdIndexRoute,
    PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsRouteRoute:
      PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsInstallationsRouteRouteWithChildren,
    PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRoute:
      PublicCustomerLocationsLocationIdElectricalProjectsProjectIdDetailsReportsRouteRouteWithChildren,
  }

const PublicCustomerLocationsLocationIdElectricalProjectsProjectIdRouteRouteWithChildren =
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdRouteRoute._addFileChildren(
    PublicCustomerLocationsLocationIdElectricalProjectsProjectIdRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  UnauthRouteRoute: UnauthRouteRouteWithChildren,
  sharedLogoutIndexRoute: sharedLogoutIndexRoute,
  sharedRedirectIndexRoute: sharedRedirectIndexRoute,
  sharedSsoIndexRoute: sharedSsoIndexRoute,
  PublicCustomerLocationsLocationIdElectricalProjectsProjectIdRouteRoute:
    PublicCustomerLocationsLocationIdElectricalProjectsProjectIdRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
